(function () {

    var laroute = (function () {

        var routes = {

            absolute: false,
            rootUrl: 'http://yourparkingspace.localhost:8080',
            routes : [
    {
        "uri": "api\/octoverse\/locations\/{country}\/{party}\/{locationId}\/{evseId?}\/{connectorId?}",
        "name": "octoverse.webhooks.location.put"
    },
    {
        "uri": "api\/octoverse\/locations\/{country}\/{party}\/{locationId}\/{evseId}",
        "name": "octoverse.webhooks.location.patch"
    },
    {
        "uri": "api\/octoverse\/tariffs\/{country}\/{party}\/{tariffId}",
        "name": "octoverse.webhooks.tariff.put"
    },
    {
        "uri": "api\/v2\/ev\/locations\/search",
        "name": "api.v2.ev.locations.search"
    },
    {
        "uri": "api\/v2\/ev\/locations\/{locationId}",
        "name": "api.v2.ev.locations.get"
    },
    {
        "uri": "api\/v2\/ev\/tariffs",
        "name": "api.v2.ev.tariffs.get"
    },
    {
        "uri": "_debugbar\/open",
        "name": "debugbar.openhandler"
    },
    {
        "uri": "_debugbar\/clockwork\/{id}",
        "name": "debugbar.clockwork"
    },
    {
        "uri": "_debugbar\/assets\/stylesheets",
        "name": "debugbar.assets.css"
    },
    {
        "uri": "_debugbar\/assets\/javascript",
        "name": "debugbar.assets.js"
    },
    {
        "uri": "_debugbar\/cache\/{key}\/{tags?}",
        "name": "debugbar.cache.delete"
    },
    {
        "uri": "_debugbar\/queries\/explain",
        "name": "debugbar.queries.explain"
    },
    {
        "uri": "login",
        "name": "login"
    },
    {
        "uri": "login",
        "name": "auth.login"
    },
    {
        "uri": "two-factor",
        "name": "auth.two-factor"
    },
    {
        "uri": "two-factor",
        "name": "auth.two-factor"
    },
    {
        "uri": "logout",
        "name": "auth.logout"
    },
    {
        "uri": "forgotten-password",
        "name": "auth.forgotten-password"
    },
    {
        "uri": "forgotten-password",
        "name": "auth.forgotten-password"
    },
    {
        "uri": "forgotten-password\/{token}",
        "name": "auth.forgotten-password.reset"
    },
    {
        "uri": "forgotten-password\/{token}",
        "name": "auth.forgotten-password.reset"
    },
    {
        "uri": "\/",
        "name": "admin.index"
    },
    {
        "uri": "me",
        "name": "admin.me"
    },
    {
        "uri": "me",
        "name": "admin.me"
    },
    {
        "uri": "me\/security",
        "name": "admin.me.security"
    },
    {
        "uri": "me\/security\/2factor",
        "name": "admin.me.security.2fa"
    },
    {
        "uri": "me\/security\/2factor",
        "name": "admin.me.security.2fa"
    },
    {
        "uri": "me\/security\/2factor\/disable",
        "name": "admin.me.security.2fa-disable"
    },
    {
        "uri": "me\/security\/2factor\/disable",
        "name": "admin.me.security.2fa-disable"
    },
    {
        "uri": "api\/v2\/auth\/two_factor_trigger",
        "name": "api.v2.auth.two-factor-trigger"
    },
    {
        "uri": "api\/v2\/sms-message-status",
        "name": "api.v2.sms-message-status"
    },
    {
        "uri": "api\/v2\/integrations\/s-n-b\/parking-notifications\/{transactionReferenceId}",
        "name": "api.v2.sb-parking-notification"
    },
    {
        "uri": "api\/v2\/space-feed",
        "name": "api.v2.space-feed"
    },
    {
        "uri": "api\/v2\/mobile-kiosk\/configs\/{spaceId}",
        "name": "api.v2.web.flow.configs"
    },
    {
        "uri": "api\/v2\/mobile-kiosk\/vrn\/{spaceId}",
        "name": "api.v2.web.flow.vrn"
    },
    {
        "uri": "api\/v2\/mobile-kiosk\/vrn-suggest\/{spaceId}",
        "name": "api.v2.web.flow.vrn-suggest"
    },
    {
        "uri": "api\/v2\/mobile-kiosk\/pre-pay-duration\/{spaceId}",
        "name": "api.v2.web.flow.pre.pay.duration"
    },
    {
        "uri": "api\/v2\/mobile-kiosk\/quote-pay-on-arrival\/{spaceId}",
        "name": "api.v2.web.flow.pre.pay.quote"
    },
    {
        "uri": "api\/v2\/mobile-kiosk\/post-pay-no-vrn\/{spaceId}",
        "name": "api.v2.web.flow.post.pay.no-vrn"
    },
    {
        "uri": "api\/v2\/mobile-kiosk\/payment\/{spaceId}",
        "name": "api.v2.web.flow.payment"
    },
    {
        "uri": "api\/v2\/mobile-kiosk\/update-booking",
        "name": "api.v2.web.flow.update-booking"
    },
    {
        "uri": "api\/v2\/mobile-kiosk\/discount-code\/{spaceId}",
        "name": "api.v2.web.flow.discount-code"
    },
    {
        "uri": "api\/v2\/mobile-kiosk\/intent\/{space}",
        "name": "api.v2.web.flow.intent"
    },
    {
        "uri": "api\/v2\/mobile-kiosk\/intent-action\/{space}",
        "name": "api.v2.web.flow.intent-action"
    },
    {
        "uri": "api\/v2\/mobile-kiosk\/intent-cancel\/{space}",
        "name": "api.v2.web.flow.intent-cancel"
    },
    {
        "uri": "api\/v2\/mobile-kiosk\/intent-payment\/{space}",
        "name": "api.v2.web.flow.intent-payment"
    },
    {
        "uri": "api\/v2\/mobile-kiosk\/intent-test-payment\/{space}",
        "name": "api.v2.web.flow.intent-test-payment"
    },
    {
        "uri": "api\/v2\/kengine\/booking",
        "name": "api.v2.kengine.booking"
    },
    {
        "uri": "api\/v2\/lps\/booking\/{space}\/{kiosk}",
        "name": "api.v2.lps.booking"
    },
    {
        "uri": "api\/v2\/lps\/receipt\/{space}\/{kiosk}",
        "name": "api.v2.lps.receipt"
    },
    {
        "uri": "api\/v2\/check-email",
        "name": "api.v2.check-email"
    },
    {
        "uri": "api\/v2\/guest-validation\/{companyId}\/{spaceId}\/{code}",
        "name": "api.v2.guest-validation"
    },
    {
        "uri": "api\/v2\/guest-validation\/{companyId}\/{space}\/{code}",
        "name": "api.v2.guest-validation.book"
    },
    {
        "uri": "api\/v2\/social\/check",
        "name": "api.v2.social.check"
    },
    {
        "uri": "api\/v2\/forgot-password",
        "name": "api.v2.forgotten-password"
    },
    {
        "uri": "api\/v2\/reset-password",
        "name": "api.v2.reset-password"
    },
    {
        "uri": "api\/v2\/contact-us",
        "name": "api.v2.contact-us"
    },
    {
        "uri": "api\/v2\/self-serve\/bookings\/{booking}",
        "name": "api.v2.self-serve.booking.show"
    },
    {
        "uri": "api\/v2\/self-serve\/guest\/refund",
        "name": "api.v2.self-serve.refund.guest.submit"
    },
    {
        "uri": "api\/v2\/self-serve\/refund",
        "name": "api.v2.self-serve.refund.submit"
    },
    {
        "uri": "api\/v2\/search",
        "name": "api.v2.search"
    },
    {
        "uri": "api\/v2\/location-search",
        "name": "api.v2.location-search"
    },
    {
        "uri": "api\/v2\/recommended-prices",
        "name": "api.v2.recommended-prices"
    },
    {
        "uri": "api\/v2\/pricing-statistics",
        "name": "api.v2.pricing-statistics"
    },
    {
        "uri": "api\/v2\/nearby-events",
        "name": "api.v2.nearby-events"
    },
    {
        "uri": "api\/v2\/parking-statistics",
        "name": "api.v2.parking-statistics"
    },
    {
        "uri": "api\/v2\/location-summary",
        "name": "api.v2.location-summary"
    },
    {
        "uri": "api\/v2\/spaces\/{space}",
        "name": "api.v2.spaces.show"
    },
    {
        "uri": "api\/v2\/spaces\/{space}\/info",
        "name": "api.v2.space-info"
    },
    {
        "uri": "api\/v2\/spaces\/{space}\/availability",
        "name": "api.v2.space-availability"
    },
    {
        "uri": "api\/v2\/spaces\/{space}\/quote",
        "name": "api.v2.quote"
    },
    {
        "uri": "api\/v2\/spaces\/{space}\/quote\/multi",
        "name": "api.v2.multi-quote"
    },
    {
        "uri": "api\/v2\/location-reviews",
        "name": "api.v2.location-reviews"
    },
    {
        "uri": "api\/v2\/tenant\/bookings\/{booking}\/reviews",
        "name": "api.v2.booking-review.view-booking"
    },
    {
        "uri": "api\/v2\/tenant\/bookings\/{booking}\/reviews",
        "name": "api.v2.booking-review.store"
    },
    {
        "uri": "api\/v2\/vehicle-information\/makes",
        "name": "api.v2.vehicle-information.makes"
    },
    {
        "uri": "api\/v2\/vehicle-information\/{registration}",
        "name": "api.v2.vehicle-information"
    },
    {
        "uri": "api\/v2\/auto-pay\/set-up\/check-email",
        "name": "api.v2.auto-pay.set-up.check-email"
    },
    {
        "uri": "api\/v2\/auto-pay\/set-up\/register",
        "name": "api.v2.auto-pay.set-up.register"
    },
    {
        "uri": "api\/v2\/auto-pay\/vehicle-detected",
        "name": "api.v2.auto-pay.vehicle-detected"
    },
    {
        "uri": "api\/v2\/auto-pay\/register-discount\/store",
        "name": "api.v2.auto-pay.register-discount.store"
    },
    {
        "uri": "api\/v2\/confirm-access-equipment-returned\/{booking}",
        "name": "confirm-access-equipment-returned"
    },
    {
        "uri": "api\/v2\/search-engine-indexed-spaces",
        "name": "api.v2.search-engine-indexed-spaces"
    },
    {
        "uri": "api\/v2\/search-engine-indexed-space-paths",
        "name": "api.v2.search-engine-indexed-space-paths"
    },
    {
        "uri": "api\/v2\/bookings\/active-at",
        "name": "api.v2.bookings.active-at"
    },
    {
        "uri": "api\/v2\/spaces\/landlord\/{id}\/disable",
        "name": "account.api.landlord.spaces.disable"
    },
    {
        "uri": "api\/v2\/spaces\/landlord\/{id}\/enable",
        "name": "account.api.landlord.spaces.enable"
    },
    {
        "uri": "api\/v2\/spaces\/landlord\/{id}\/remove",
        "name": "account.api.landlord.spaces.remove"
    },
    {
        "uri": "api\/v2\/me\/social\/connect",
        "name": "api.v2.authenticated.me.social.connect"
    },
    {
        "uri": "api\/v2\/me\/social\/{provider}\/disconnect",
        "name": "api.v2.authenticated.me.social.disconnect"
    },
    {
        "uri": "api\/v2\/me\/vouchers",
        "name": "api.v2.vouchers.index"
    },
    {
        "uri": "api\/v2\/me\/tenant\/bookings\/pending-review",
        "name": "api.v2.tenant.bookings.pending-review"
    },
    {
        "uri": "api\/v2\/me\/tenant\/bookings\/cancellation-reasons",
        "name": "api.v2.tenant.bookings.cancellation-reasons"
    },
    {
        "uri": "api\/v2\/me\/tenant\/bookings\/ending-reasons",
        "name": "api.v2.tenant.bookings.ending-reasons"
    },
    {
        "uri": "api\/v2\/me\/tenant\/bookings\/booking-locations",
        "name": "api.v2.tenant.bookings.booking-locations"
    },
    {
        "uri": "api\/v2\/me\/tenant\/bookings",
        "name": "api.v2.tenant.bookings.index"
    },
    {
        "uri": "api\/v2\/me\/tenant\/bookings\/{booking_id}",
        "name": "api.v2.tenant.bookings.show"
    },
    {
        "uri": "api\/v2\/me\/tenant\/bookings\/{booking_id}",
        "name": "api.v2.tenant.bookings.update"
    },
    {
        "uri": "api\/v2\/me\/tenant\/bookings\/{booking_id}\/end-long-term",
        "name": "api.v2.tenant.bookings.end-long-term"
    },
    {
        "uri": "api\/v2\/me\/tenant\/bookings\/{booking_id}\/quote",
        "name": "api.v2.tenant.bookings.quote"
    },
    {
        "uri": "api\/v2\/me\/tenant\/bookings\/{booking_id}\/cancel",
        "name": "api.v2.tenant.bookings.cancel"
    },
    {
        "uri": "api\/v2\/me\/tenant\/bookings\/{booking_id}\/products",
        "name": "api.v2.tenant.bookings.products.index"
    },
    {
        "uri": "api\/v2\/me\/tenant\/bookings\/{booking_id}\/products\/{product_id}",
        "name": "api.v2.tenant.bookings.products.show"
    },
    {
        "uri": "api\/v2\/me\/tenant\/bookings\/{booking_id}\/products",
        "name": "api.v2.tenant.bookings.products.purchase"
    },
    {
        "uri": "api\/v2\/me\/tenant\/bookings\/{booking_id}\/products\/{booking_product_id}",
        "name": "api.v2.tenant.bookings.products.destroy"
    },
    {
        "uri": "api\/v2\/me\/tenant\/bookings\/{booking_id}\/products\/wecovr",
        "name": "api.v2.tenant.bookings.products.wecovr"
    },
    {
        "uri": "api\/v2\/me\/tenant\/bookings\/{booking}\/products\/{product}",
        "name": "api.v2.tenant.bookings.products.update"
    },
    {
        "uri": "api\/v2\/me\/tenant\/bookings\/{booking_id}\/action-post-refund",
        "name": "api.v2.tenant.bookings.action-post-refund"
    },
    {
        "uri": "api\/v2\/me\/tenant\/bookings\/{booking_id}\/create-chat",
        "name": "api.v2.tenant.bookings.create-chat"
    },
    {
        "uri": "api\/v2\/me\/tenant\/bookings\/{booking_id}\/payment-method",
        "name": "api.v2.tenant.bookings.update-payment-method"
    },
    {
        "uri": "api\/v2\/me\/tenant\/bookings\/{booking}\/pause\/confirm",
        "name": "api.v2.tenant.bookings.pause.confirm"
    },
    {
        "uri": "api\/v2\/me\/tenant\/bookings\/{booking}\/receipts",
        "name": "api.v2.tenant.bookings.receipts.index"
    },
    {
        "uri": "api\/v2\/me\/tenant\/bookings\/{booking}\/receipts\/{tracker}",
        "name": "api.v2.tenant.bookings.receipts.download.long-term"
    },
    {
        "uri": "api\/v2\/me\/tenant\/booked-spaces\/past",
        "name": "api-v2.tenant.bookings.past-bookings"
    },
    {
        "uri": "api\/v2\/me\/tenant\/auto-pay",
        "name": "api.v2.me.tenant.auto-pay.get-settings"
    },
    {
        "uri": "api\/v2\/me\/tenant\/auto-pay\/set-up",
        "name": "api.v2.me.tenant.auto-pay.set-up"
    },
    {
        "uri": "api\/v2\/me\/tenant\/auto-pay\/save-settings",
        "name": "api.v2.me.tenant.auto-pay.save-settings"
    },
    {
        "uri": "api\/v2\/me\/tenant\/auto-pay\/find-vehicle",
        "name": "api.v2.auto-pay.set-up.find-vehicle"
    },
    {
        "uri": "api\/v2\/me\/tenant\/auto-pay\/add-vehicle",
        "name": "api.v2.auto-pay.set-up.add-vehicle"
    },
    {
        "uri": "api\/v2\/me\/tenant\/auto-pay\/enable-latest-vehicle",
        "name": "api.v2.auto-pay.set-up.enable-latest-vehicle"
    },
    {
        "uri": "api\/v2\/me\/tenant\/auto-pay\/accept-terms",
        "name": "api.v2.auto-pay.set-up.accept-terms"
    },
    {
        "uri": "api\/v2\/me\/tenant\/auto-pay\/incomplete-sessions",
        "name": "api.v2.me.tenant.auto-pay.incomplete-sessions"
    },
    {
        "uri": "api\/v2\/me\/tenant\/auto-pay\/incomplete-sessions\/{bookingId}\/complete",
        "name": "api.v2.me.tenant.auto-pay.incomplete-sessions.complete-booking"
    },
    {
        "uri": "api\/v2\/me\/tenant\/chat-bot\/bookings",
        "name": "api.v2.tenant.chat-bot.bookings"
    },
    {
        "uri": "api\/v2\/me\/space-owner\/bookings",
        "name": "account.space-owner.bookings"
    },
    {
        "uri": "api\/v2\/me\/space-owner\/bookings\/{bookingId}\/vehicle",
        "name": "account.space-owner.bookings.booking.vehicle"
    },
    {
        "uri": "api\/v2\/me\/space-owner\/bookings\/active\/in-progress",
        "name": "account.space-owner.bookings.active.in-progress"
    },
    {
        "uri": "api\/v2\/me\/space-owner\/bookings\/active\/upcoming",
        "name": "account.space-owner.bookings.active.upcoming"
    },
    {
        "uri": "api\/v2\/me\/space-owner\/bookings\/completed",
        "name": "account.space-owner.bookings.completed"
    },
    {
        "uri": "api\/v2\/me\/space-owner\/bookings\/cancelled",
        "name": "account.space-owner.bookings.cancelled"
    },
    {
        "uri": "api\/v2\/me\/space-owner\/bookings\/{booking}",
        "name": "account.space-owner.bookings.show"
    },
    {
        "uri": "api\/v2\/me\/space-owner\/locations",
        "name": "account.space-owner.locations"
    },
    {
        "uri": "api\/v2\/me\/space-owner\/account-value",
        "name": "account.space-owner.account-value"
    },
    {
        "uri": "api\/v2\/me\/space-owner\/payments\/paypal",
        "name": "account.space-owner.payments.paypal.view"
    },
    {
        "uri": "api\/v2\/me\/space-owner\/payments\/paypal",
        "name": "account.space-owner.payments.paypal.store"
    },
    {
        "uri": "api\/v2\/me\/space-owner\/payments\/transfer",
        "name": "account.space-owner.payments.transfer.view"
    },
    {
        "uri": "api\/v2\/me\/space-owner\/payments\/transfer",
        "name": "account.space-owner.payments.transfer.store"
    },
    {
        "uri": "api\/v2\/me\/corporate-account\/users\/notification-settings",
        "name": "api.v2.corporate-account.users.notification-settings.show"
    },
    {
        "uri": "api\/v2\/me\/corporate-account\/users\/notification-settings",
        "name": "api.v2.corporate-account.users.notification-settings.update"
    },
    {
        "uri": "api\/v2\/me\/corporate-account",
        "name": "api.v2.corporate-account.index"
    },
    {
        "uri": "api\/v2\/me\/corporate-account",
        "name": "api.v2.corporate-account.update"
    },
    {
        "uri": "api\/v2\/me\/corporate-account\/invoices",
        "name": "api.v2.corporate-account.invoices"
    },
    {
        "uri": "api\/v2\/me\/corporate-account\/users",
        "name": "api.v2.corporate-account.users.index"
    },
    {
        "uri": "api\/v2\/me\/corporate-account\/users",
        "name": "api.v2.corporate-account.users.store"
    },
    {
        "uri": "api\/v2\/me\/corporate-account\/users\/export",
        "name": "api.v2.corporate-account.users.export"
    },
    {
        "uri": "api\/v2\/me\/corporate-account\/users\/import",
        "name": "api.v2.corporate-account.users.import.show"
    },
    {
        "uri": "api\/v2\/me\/corporate-account\/users\/import",
        "name": "api.v2.corporate-account.users.import.store"
    },
    {
        "uri": "api\/v2\/me\/corporate-account\/users\/notification-preferences",
        "name": "api.v2.corporate-account.users.notification-preferences.show"
    },
    {
        "uri": "api\/v2\/me\/corporate-account\/users\/notification-preferences",
        "name": "api.v2.corporate-account.users.notification-preferences.store"
    },
    {
        "uri": "api\/v2\/me\/corporate-account\/users\/{user}",
        "name": "api.v2.corporate-account.users.show"
    },
    {
        "uri": "api\/v2\/me\/corporate-account\/users\/{user}\/unlink",
        "name": "api.v2.corporate-account.users.unlink"
    },
    {
        "uri": "api\/v2\/me\/corporate-account\/bookings",
        "name": "api.v2.corporate-account.bookings.index"
    },
    {
        "uri": "api\/v2\/me\/corporate-account\/bookings\/export",
        "name": "api.v2.corporate-account.bookings.export"
    },
    {
        "uri": "api\/v2\/me\/corporate-account\/bookings\/{booking}",
        "name": "api.v2.corporate-account.bookings.show"
    },
    {
        "uri": "api\/v2\/me\/corporate-account\/bookings\/{booking}\/cancel",
        "name": "api.v2.corporate-account.bookings.cancel"
    },
    {
        "uri": "api\/v2\/me\/corporate-account\/bookings\/{booking}\/receipts",
        "name": "api.v2.corporate-account.bookings.receipts.index"
    },
    {
        "uri": "api\/v2\/me\/corporate-account\/bookings\/{booking}\/receipts\/st",
        "name": "api.v2.corporate-account.bookings.receipts.download.short-term"
    },
    {
        "uri": "api\/v2\/me\/corporate-account\/bookings\/{booking}\/receipts\/lt\/{tracker}",
        "name": "api.v2.corporate-account.bookings.receipts.download.long-term"
    },
    {
        "uri": "api\/v2\/vehicles",
        "name": "api.v2.vehicles"
    },
    {
        "uri": "api\/v2\/vehicles",
        "name": "api.v2.vehicles.store"
    },
    {
        "uri": "api\/v2\/vehicles\/{id}",
        "name": "api.v2.vehicles.view"
    },
    {
        "uri": "api\/v2\/vehicles\/{id}",
        "name": "api.v2.vehicles.update"
    },
    {
        "uri": "api\/v2\/vehicles\/{id}",
        "name": "api.v2.vehicles.patch"
    },
    {
        "uri": "api\/v2\/vehicles\/{id}",
        "name": "api.v2.vehicles.delete"
    },
    {
        "uri": "api\/v2\/vehicles\/{id}\/add-to-bookings",
        "name": "api.v2.vehicles.add-to-bookings"
    },
    {
        "uri": "api\/v2\/vehicles\/{id}\/update-data",
        "name": "api.v2.vehicles.update-data"
    },
    {
        "uri": "api\/v2\/listing\/countries",
        "name": "api.v2.listings.get-countries"
    },
    {
        "uri": "api\/v2\/listing",
        "name": "api.v2.listings.store"
    },
    {
        "uri": "api\/v2\/listing\/{space}",
        "name": "api.v2.listings.show"
    },
    {
        "uri": "api\/v2\/listing\/{space}",
        "name": "api.v2.listings.update"
    },
    {
        "uri": "api\/v2\/listing\/{space}",
        "name": "api.v2.listings.delete"
    },
    {
        "uri": "api\/v2\/listing\/{space}\/availability",
        "name": "api.v2.listings.space.availability"
    },
    {
        "uri": "api\/v2\/listing\/{space}\/details",
        "name": "api.v2.listings.space.details"
    },
    {
        "uri": "api\/v2\/listing\/{space}\/photo\/{photo}",
        "name": "api.v2.listings.space.remove-photo"
    },
    {
        "uri": "api\/v2\/listing\/utility\/features",
        "name": "api.v2.listings.utilities.features"
    },
    {
        "uri": "api\/v2\/listing\/utility\/sizes",
        "name": "api.v2.listings.utilities.sizes"
    },
    {
        "uri": "api\/v2\/listing\/utility\/listings",
        "name": "api-v2.utility.listings"
    },
    {
        "uri": "api\/v2\/listing\/utility\/additional-information-rules",
        "name": "api.v2.listings.utilities.additional-information-rules"
    },
    {
        "uri": "api\/v2\/listing\/{space}\/reset-granular-availability",
        "name": "list-space.reset-granular-availability"
    },
    {
        "uri": "api\/v2\/whitelabel\/{instance}",
        "name": "whitelabel.update"
    },
    {
        "uri": "api\/v2\/whitelabel\/{instance}\/logo",
        "name": "whitelabel.logo"
    },
    {
        "uri": "api\/v2\/whitelabel\/{instance}\/spaces\/{space}",
        "name": "whitelabel.deleteSpace"
    },
    {
        "uri": "api\/v2\/countries",
        "name": "api.v2.get-countries"
    },
    {
        "uri": "api\/v2\/misc\/user-notifications\/unsubscribe",
        "name": "api.v2.misc.user-notifications.unsubscribe"
    },
    {
        "uri": "api\/v2\/misc\/location-notifications\/unsubscribe",
        "name": "api.v2.misc.location-notifications.unsubscribe"
    },
    {
        "uri": "api\/v2\/internal\/bookings\/active-at",
        "name": "api.v2.internal.bookings.active-at"
    },
    {
        "uri": "api\/v2\/internal\/spaces",
        "name": "api.v2.internal.spaces.index"
    },
    {
        "uri": "api\/v2\/internal\/spaces\/{space}",
        "name": "api.v2.internal.spaces.show"
    },
    {
        "uri": "api\/v2\/internal\/user",
        "name": "api.v2.internal.user.getOrCreate"
    },
    {
        "uri": "api\/v2\/internal\/users",
        "name": "api.v2.internal.user.index"
    },
    {
        "uri": "api\/v2\/internal\/users\/{user}",
        "name": "api.v2.internal.user.show"
    },
    {
        "uri": "api\/v2\/internal\/user\/payment-method",
        "name": "api.v2.internal.user.payment-method"
    },
    {
        "uri": "api\/v2\/internal\/bookings\/{booking}",
        "name": "api.v2.internal.bookings.show"
    },
    {
        "uri": "api\/v2\/internal\/rate-card\/single-vrm",
        "name": "api.v2.internal.rate-card.single-vrm.save"
    },
    {
        "uri": "api\/v2\/integrations\/ringgo\/sessions",
        "name": "api.v2.integrations.ringgo.sessions.store"
    },
    {
        "uri": "api\/v2\/integrations\/ringgo\/sessions",
        "name": "api.v2.integrations.ringgo.sessions.show"
    },
    {
        "uri": "api\/v2\/integrations\/ringgo\/sessions\/{session_id}",
        "name": "api.v2.integrations.ringgo.sessions.destroy"
    },
    {
        "uri": "register",
        "name": "auth.register"
    },
    {
        "uri": "search",
        "name": "search"
    },
    {
        "uri": "_ajax\/get_terms\/{type}",
        "name": "space.get_terms"
    },
    {
        "uri": "_ajax\/login",
        "name": "auth.ajax-login"
    },
    {
        "uri": "_ajax\/social-login",
        "name": "auth.ajax-social-login"
    },
    {
        "uri": "_ajax\/me",
        "name": "auth.me"
    },
    {
        "uri": "_ajax\/analytics-user",
        "name": "analytics.me"
    },
    {
        "uri": "_ajax\/reviews",
        "name": "search.reviews"
    },
    {
        "uri": "_ajax\/logout",
        "name": "auth.ajax-logout"
    },
    {
        "uri": "_ajax\/spaces\/{spaceId}\/purchase\/admin",
        "name": "ajax.space.purchase-admin"
    },
    {
        "uri": "social-login\/apple",
        "name": "auth.social-login-apple-callback"
    },
    {
        "uri": "consent\/give",
        "name": "consent.give"
    },
    {
        "uri": "refer-a-friend",
        "name": "refer-a-friend"
    },
    {
        "uri": "_utils\/barcode\/{code}\/{width}\/{height}\/{type}",
        "name": "utils.barcode"
    },
    {
        "uri": "_utils\/qr-code\/{code}\/{width}\/{height}",
        "name": "utils.qr-code"
    },
    {
        "uri": "locations\/show\/{spaceId}",
        "name": "space.show"
    },
    {
        "uri": "locations\/show\/{spaceId}\/book",
        "name": "space.book"
    },
    {
        "uri": "leave-review\/{booking}",
        "name": "leave-review.booking"
    },
    {
        "uri": "leave-review\/{booking}",
        "name": "leave-review.booking"
    },
    {
        "uri": "stripe\/webhooks",
        "name": "stripe.webhooks"
    },
    {
        "uri": "apple\/webhooks",
        "name": "apple.webhooks"
    },
    {
        "uri": "gocardless\/webhooks",
        "name": "gocardless.webhooks"
    },
    {
        "uri": "twilio\/availability-reply",
        "name": "twilio.availability-reply"
    },
    {
        "uri": "location-notifications",
        "name": "location-notifications.store"
    },
    {
        "uri": "location-notifications\/unsubscribe",
        "name": "location-notifications.unsubscribe"
    },
    {
        "uri": "location-notifications\/do-unsubscribe",
        "name": "location-notifications.do-unsubscribe"
    },
    {
        "uri": "evoke\/kiosk\/config\/{kiosk_id}",
        "name": "evoke-kiosk.config"
    },
    {
        "uri": "evoke\/kiosk\/open-barrier\/{kiosk}",
        "name": "evoke-kiosk.open-barrier"
    },
    {
        "uri": "evoke\/kiosk\/booking\/{kiosk}",
        "name": "evoke-kiosk.booking"
    },
    {
        "uri": "evoke\/kiosk\/booking\/{kiosk}\/unconfirmed",
        "name": "evoke-kiosk.booking.unconfirmed"
    },
    {
        "uri": "evoke\/kiosk\/booking\/{kiosk}\/{booking}",
        "name": "evoke-kiosk.booking.confirm"
    },
    {
        "uri": "evoke\/kiosk\/booking\/{kiosk}",
        "name": "evoke-kiosk.booking-cancel"
    },
    {
        "uri": "evoke\/kiosk\/vrn\/{kiosk}",
        "name": "evoke-kiosk.vrn-lookup"
    },
    {
        "uri": "evoke\/kiosk\/vrn-space\/{spaceIds}",
        "name": "evoke-kiosk.vrn-lookup-space"
    },
    {
        "uri": "evoke\/kiosk\/vrn-suggest\/{kiosk}",
        "name": "evoke-kiosk.vrn-suggest"
    },
    {
        "uri": "evoke\/kiosk\/post-pay-no-vrn\/{kiosk}",
        "name": "evoke-kiosk.no-vrn"
    },
    {
        "uri": "evoke\/kiosk\/pre-pay-no-vrn\/{kiosk}",
        "name": "evoke-kiosk.pre-pay-quote"
    },
    {
        "uri": "evoke\/kiosk\/receipt",
        "name": "evoke-kiosk.receipt"
    },
    {
        "uri": "evoke\/kiosk\/promos\/{kiosk}",
        "name": "evoke-kiosk.promo"
    },
    {
        "uri": "evoke\/kiosk\/discount-code\/{kiosk}",
        "name": "evoke-kiosk.discount-code"
    },
    {
        "uri": "evoke\/kiosk\/check-discount-code\/{kiosk}",
        "name": "evoke-kiosk.check-discount-code"
    },
    {
        "uri": "_misc\/parkopedia",
        "name": "misc.parkopedia"
    },
    {
        "uri": "_misc\/parking-scheme",
        "name": "misc.parking-scheme"
    },
    {
        "uri": "_misc\/parklet",
        "name": "misc.parklet"
    },
    {
        "uri": "_misc\/park-on-my-drive",
        "name": "misc.park-on-my-drive"
    },
    {
        "uri": "_misc\/imperial",
        "name": "misc.imperial"
    },
    {
        "uri": "_misc\/allow-to-action",
        "name": "misc.allow-to-action"
    },
    {
        "uri": "_misc\/justpark\/list",
        "name": "justpark.list"
    },
    {
        "uri": "_misc\/justpark\/{space}\/quote",
        "name": "justpark.quote"
    },
    {
        "uri": "_misc\/justpark\/{space}\/book",
        "name": "justpark.book"
    },
    {
        "uri": "_misc\/justpark\/bookings\/{booking}",
        "name": "justpark.update"
    },
    {
        "uri": "_misc\/justpark\/bookings\/{booking}",
        "name": "justpark.delete"
    },
    {
        "uri": "_misc\/imperial\/{space}\/book",
        "name": "imperial.book"
    },
    {
        "uri": "_misc\/imperial\/bookings\/{booking}",
        "name": "imperial.update"
    },
    {
        "uri": "_misc\/imperial\/bookings\/{booking}",
        "name": "imperial.delete"
    },
    {
        "uri": "_misc\/earth-day-bookings",
        "name": "misc.earth-day-bookings"
    },
    {
        "uri": "_misc\/skidata",
        "name": "misc.skidata"
    },
    {
        "uri": "_misc\/ivr\/availability",
        "name": "misc.ivr.availability"
    },
    {
        "uri": "_misc\/long-term-plans",
        "name": "misc.long-term-plans"
    },
    {
        "uri": "_misc\/contact\/support-subjects",
        "name": "misc.contact.support-subjects"
    },
    {
        "uri": "ocs",
        "name": "ocs"
    },
    {
        "uri": "ocs\/contact",
        "name": "ocs.contact"
    },
    {
        "uri": "payment-authorization\/success",
        "name": "payment-authorization.success"
    },
    {
        "uri": "payment-authorization\/error",
        "name": "payment-authorization.error"
    },
    {
        "uri": "payment-authorization\/{token}",
        "name": "payment-authorization.index"
    },
    {
        "uri": "payment-authorization\/gocardless\/biller-migration-flow\/{token}",
        "name": "payment-authorization.gocardless.biller-migration-flow"
    },
    {
        "uri": "payment-authorization\/gocardless\/biller-migration-flow\/{token}\/success",
        "name": "payment-authorization.gocardless.biller-migration-flow.execute"
    },
    {
        "uri": "payment-authorization\/stripe\/biller-migration-flow\/{token}",
        "name": "payment-authorization.stripe.biller-migration-flow"
    },
    {
        "uri": "payment-authorization\/stripe\/biller-migration-flow\/{token}",
        "name": "payment-authorization.stripe.biller-migration-flow.execute"
    },
    {
        "uri": "payment-authorization\/braintree\/biller-migration-flow\/{token}",
        "name": "payment-authorization.braintree.biller-migration-flow"
    },
    {
        "uri": "payment-authorization\/braintree\/biller-migration-flow\/{token}",
        "name": "payment-authorization.braintree.biller-migration-flow.execute"
    },
    {
        "uri": "unsubscribe\/{email}\/{notificationType}",
        "name": "unsubscribe.notification"
    },
    {
        "uri": "unsubscribe",
        "name": "unsubscribe.notification.submit"
    },
    {
        "uri": "calendar",
        "name": "get-calendar"
    },
    {
        "uri": "parking-management",
        "name": "parking-management"
    },
    {
        "uri": "parking-management",
        "name": "parking-management.check-registration"
    },
    {
        "uri": "parking-management\/mark-drive-up",
        "name": "parking-management.mark-drive-up"
    },
    {
        "uri": "parking-management\/get-remaining-spaces",
        "name": "parking-management.get-remaining-spaces"
    },
    {
        "uri": "respond-availability-available",
        "name": "respond-availability-available"
    },
    {
        "uri": "respond-availability-unavailable",
        "name": "respond-availability-unavailable"
    },
    {
        "uri": "{any?}",
        "name": "list-space.about"
    },
    {
        "uri": "{space}\/progress",
        "name": "list-space.about-edit"
    },
    {
        "uri": "resend-sms-verification",
        "name": "account.resend-sms-verification"
    },
    {
        "uri": "verify-sms",
        "name": "account.verify-sms"
    },
    {
        "uri": "\/",
        "name": "account"
    },
    {
        "uri": "_ajax\/view_booking\/{id}",
        "name": "account.ajax.get_booking"
    },
    {
        "uri": "set-password",
        "name": "account.set-password"
    },
    {
        "uri": "resend-sms-verification",
        "name": "account.resend-sms-verification"
    },
    {
        "uri": "verify-sms",
        "name": "account.verify-sms"
    },
    {
        "uri": "resend-email-verification",
        "name": "account.resend-email-verification"
    },
    {
        "uri": "profile",
        "name": "account.profile"
    },
    {
        "uri": "tenant\/notification-settings",
        "name": "account.tenant.notification-settings"
    },
    {
        "uri": "tenant\/open-zendesk-ticket",
        "name": "account.tenant.open-zendesk-ticket"
    },
    {
        "uri": "tenant\/verify-email\/{verification_code}",
        "name": "account.tenant.verify-email"
    },
    {
        "uri": "tenant\/verify-sms",
        "name": "account.tenant.verify-sms"
    },
    {
        "uri": "tenant\/verify-sms\/success",
        "name": "account.tenant.verify-sms.success"
    },
    {
        "uri": "tenant\/profile",
        "name": "account.tenant.profile"
    },
    {
        "uri": "tenant\/notification-settings",
        "name": "account.tenant.notification-settings"
    },
    {
        "uri": "tenant\/promos",
        "name": "account.tenant.promos"
    },
    {
        "uri": "tenant\/refer-a-friend",
        "name": "account.tenant.refer-a-friend"
    },
    {
        "uri": "tenant\/trust",
        "name": "account.tenant.trust"
    },
    {
        "uri": "tenant\/security",
        "name": "account.tenant.security"
    },
    {
        "uri": "tenant\/help",
        "name": "account.tenant.help"
    },
    {
        "uri": "tenant",
        "name": "account.tenant.dashboard"
    },
    {
        "uri": "tenant\/bookings\/{id}",
        "name": "account.tenant.booking"
    },
    {
        "uri": "tenant\/end-bookings\/{id}",
        "name": "account.tenant.end-booking"
    },
    {
        "uri": "tenant\/bookings\/{id}\/failed-payment",
        "name": "account.tenant.booking.failed-payment"
    },
    {
        "uri": "tenant\/bookings\/{bookingId}\/extend\/admin",
        "name": "ajax.account.tenant.extend-admin"
    },
    {
        "uri": "tenant\/payment-methods",
        "name": "account.tenant.payment-methods"
    },
    {
        "uri": "tenant\/your-vehicles\/{any?}",
        "name": "account.tenant.your-vehicles"
    },
    {
        "uri": "tenant\/past-reservations",
        "name": "account.tenant.past-reservations"
    },
    {
        "uri": "tenant\/past-reservations\/{id}",
        "name": "account.tenant.past-reservations.booking"
    },
    {
        "uri": "tenant\/reservations\/{bookingId}\/cancel",
        "name": "account.tenant.reservations.cancel-booking"
    },
    {
        "uri": "tenant\/reservations\/{bookingId}\/change-vehicle",
        "name": "account.tenant.reservations.change-vehicle"
    },
    {
        "uri": "tenant\/reservations\/{bookingId}\/pdf\/{download?}",
        "name": "account.tenant.reservations.download-pdf"
    },
    {
        "uri": "tenant\/reservations\/{bookingId}\/pdf\/email",
        "name": "account.tenant.reservations.email-pdf"
    },
    {
        "uri": "tenant\/payments\/{trackerId}\/pdf",
        "name": "account.tenant.payments.download-lt-pdf"
    },
    {
        "uri": "tenant\/reservations\/{bookingId}\/resend-booking-confirmation",
        "name": "account.tenant.reservations.resend-booking-confirmation"
    },
    {
        "uri": "tenant\/auto-pay",
        "name": "account.tenant.auto-pay"
    },
    {
        "uri": "tenant\/auto-pay\/honesty",
        "name": "account.tenant.auto-pay.honesty-mode"
    },
    {
        "uri": "tenant\/auto-pay\/{booking}\/still-parked",
        "name": "account.tenant.auto-pay.still-parked"
    },
    {
        "uri": "landlord\/notification-settings",
        "name": "account.landlord.notification-settings"
    },
    {
        "uri": "landlord\/open-zendesk-ticket",
        "name": "account.landlord.open-zendesk-ticket"
    },
    {
        "uri": "landlord\/verify-email\/{verification_code}",
        "name": "account.landlord.verify-email"
    },
    {
        "uri": "landlord\/verify-sms",
        "name": "account.landlord.verify-sms"
    },
    {
        "uri": "landlord\/verify-sms\/success",
        "name": "account.landlord.verify-sms.success"
    },
    {
        "uri": "landlord\/profile",
        "name": "account.landlord.profile"
    },
    {
        "uri": "landlord\/notification-settings",
        "name": "account.landlord.notification-settings"
    },
    {
        "uri": "landlord\/promos",
        "name": "account.landlord.promos"
    },
    {
        "uri": "landlord\/refer-a-friend",
        "name": "account.landlord.refer-a-friend"
    },
    {
        "uri": "landlord\/trust",
        "name": "account.landlord.trust"
    },
    {
        "uri": "landlord\/security",
        "name": "account.landlord.security"
    },
    {
        "uri": "landlord\/help",
        "name": "account.landlord.help"
    },
    {
        "uri": "landlord",
        "name": "account.landlord.dashboard"
    },
    {
        "uri": "landlord\/reservations{any?}",
        "name": "account.landlord.bookings"
    },
    {
        "uri": "landlord\/bookings\/active\/in-progress\/export",
        "name": "account.space-owner.bookings.active.in-progress.export"
    },
    {
        "uri": "landlord\/bookings\/active\/upcoming\/export",
        "name": "account.space-owner.bookings.active.upcoming.export"
    },
    {
        "uri": "landlord\/bookings\/completed\/export",
        "name": "account.space-owner.bookings.completed.export"
    },
    {
        "uri": "landlord\/bookings\/cancelled\/export",
        "name": "account.space-owner.bookings.cancelled.export"
    },
    {
        "uri": "landlord\/payments",
        "name": "account.landlord.payments"
    },
    {
        "uri": "landlord\/payments",
        "name": "account.landlord.payments"
    },
    {
        "uri": "landlord\/user",
        "name": "account.landlord.get-user"
    },
    {
        "uri": "landlord\/taxinformation",
        "name": "account.landlord.tax.index"
    },
    {
        "uri": "landlord\/taxinformation",
        "name": "account.landlord.tax.store"
    },
    {
        "uri": "landlord\/earnings",
        "name": "account.landlord.earnings"
    },
    {
        "uri": "landlord\/whitelabel\/{instance}\/edit",
        "name": "account.whitelabel.edit"
    },
    {
        "uri": "landlord\/whitelabel\/{instance}\/edit",
        "name": "account.whitelabel.edit"
    },
    {
        "uri": "landlord\/listings",
        "name": "account.landlord.listings"
    },
    {
        "uri": "landlord\/listings\/{id}\/edit",
        "name": "account.landlord.listings.edit"
    },
    {
        "uri": "landlord\/listings\/{id}\/disable",
        "name": "account.landlord.spaces.disable"
    },
    {
        "uri": "landlord\/listings\/{id}",
        "name": "account.landlord.spaces.delete"
    },
    {
        "uri": "landlord\/listings\/{id}\/enable",
        "name": "account.landlord.spaces.enable"
    },
    {
        "uri": "landlord\/listings\/{id}\/enable",
        "name": "account.landlord.spaces.enable"
    },
    {
        "uri": "landlord\/listings\/{id}\/availability-enable",
        "name": "account.landlord.spaces.availability-enable"
    },
    {
        "uri": "landlord\/listings\/{id}\/availability-disable",
        "name": "account.landlord.spaces.availability-disable"
    },
    {
        "uri": "set-up",
        "name": "auto-pay.set-up"
    },
    {
        "uri": "set-up\/auth",
        "name": "auto-pay.auth"
    },
    {
        "uri": "set-up\/terms",
        "name": "auto-pay.terms"
    },
    {
        "uri": "set-up\/register",
        "name": "auto-pay.register"
    },
    {
        "uri": "register-discount",
        "name": "auto-pay.register-discount"
    },
    {
        "uri": "whitelist\/url-qr-code",
        "name": "auto-pay.whitelist.url-qr-code"
    },
    {
        "uri": "admin\/api\/locations\/{space}\/save-post-pay-settings",
        "name": "hatchly.api.space-info.save-post-pay-settings"
    },
    {
        "uri": "admin\/api\/locations\/{spaceId}\/booking-count",
        "name": "hatchly.api.space-info.booking-count"
    },
    {
        "uri": "admin\/api\/locations\/booked-count",
        "name": "hatchly.api.spaces.booked-count"
    },
    {
        "uri": "admin\/api\/locations\/{space}\/save-kiosk-durations",
        "name": "hatchly.api.space-info.save-kiosk-durations"
    },
    {
        "uri": "admin\/api\/locations\/{spaceId}\/save-service-fees",
        "name": "hatchly.api.space-info.save-service-fees"
    },
    {
        "uri": "admin\/api\/locations\/{spaceId}\/skip-availability-check-cashless",
        "name": "hatchly.api.space-info.skip-availability-check-cashless"
    },
    {
        "uri": "admin\/api\/locations\/{spaceId}\/pricing\/save-tariff-pricing-model",
        "name": "hatchly.api.space-info.pricing.save-tariff-pricing-model"
    },
    {
        "uri": "admin\/api\/locations\/{spaceId}\/pricing\/save-post-max-tariff-model",
        "name": "hatchly.api.space-info.pricing.save-post-max-tariff-model"
    },
    {
        "uri": "admin\/api\/locations\/{spaceId}\/pricing\/save-short-term",
        "name": "hatchly.api.space-info.pricing.save-short-term"
    },
    {
        "uri": "admin\/api\/locations\/{spaceId}\/pricing\/save-kiosk-service-fees",
        "name": "hatchly.api.space-info.pricing.save-kiosk-service-fees"
    },
    {
        "uri": "admin\/api\/locations\/{spaceId}\/pricing\/save-tariff-board",
        "name": "hatchly.api.space-info.pricing.save-tariff-board"
    },
    {
        "uri": "admin\/api\/locations\/{spaceId}\/pricing\/save-tariff-board-order",
        "name": "hatchly.api.space-info.pricing.save-tariff-board-order"
    },
    {
        "uri": "admin\/api\/locations\/{spaceId}\/pricing\/delete-tariff-board\/{boardId}",
        "name": "hatchly.api.space-info.pricing.delete-tariff-board"
    },
    {
        "uri": "admin\/api\/locations\/{spaceId}\/pricing\/get-rate-card-logs",
        "name": "hatchly.api.space-info.pricing.get-rate-card-logs"
    },
    {
        "uri": "admin\/api\/locations\/{spaceId}\/pricing\/save-rate-card",
        "name": "hatchly.api.space-info.pricing.save-rate-card"
    },
    {
        "uri": "admin\/api\/locations\/{spaceId}\/pricing\/delete-rate-card\/{rateCard}",
        "name": "hatchly.api.space-info.pricing.delete-rate-card"
    },
    {
        "uri": "admin\/api\/locations\/{space}\/pricing\/save-season-pricing",
        "name": "hatchly.api.space-info.pricing.save-season-pricing"
    },
    {
        "uri": "admin\/api\/locations\/ratecard\/{rateCard}\/get-rate-card-items\/{rateCardType}",
        "name": "hatchly.api.space-info.pricing.get-rate-card-items"
    },
    {
        "uri": "admin\/api\/locations\/ratecard\/{rateCard}\/add-rate-card-items\/{rateCardType}",
        "name": "hatchly.api.space-info.pricing.add-rate-card-item"
    },
    {
        "uri": "admin\/api\/locations\/ratecard\/{rateCard}\/search-rate-card-items\/{rateCardType}\/{item}",
        "name": "hatchly.api.space-info.pricing.search-rate-card-item"
    },
    {
        "uri": "admin\/api\/locations\/ratecard\/{rateCard}\/remove-rate-card-items\/{rateCardType}\/{item}",
        "name": "hatchly.api.space-info.pricing.remove-rate-card-item"
    },
    {
        "uri": "admin\/api\/locations\/ratecard\/{rateCard}\/save-tariff-pricing-model",
        "name": "hatchly.api.space-info.pricing.rate-card.save-tariff-pricing-model"
    },
    {
        "uri": "admin\/api\/locations\/ratecard\/{rateCard}\/save-post-max-tariff-model",
        "name": "hatchly.api.space-info.pricing.rate-card.save-post-max-tariff-model"
    },
    {
        "uri": "admin\/api\/locations\/{spaceId}\/dynamic-pricing\/get-for-date",
        "name": "hatchly.api.space.dynamic-pricing.get-for-date"
    },
    {
        "uri": "admin\/api\/locations\/{spaceId}\/dynamic-pricing\/save",
        "name": "hatchly.api.space-info.dynamic-pricing.save"
    },
    {
        "uri": "admin\/api\/locations\/{spaceId}\/save-auto-pay",
        "name": "hatchly.api.spaces.save-auto-pay"
    },
    {
        "uri": "admin\/api\/locations\/{space}\/linked-spaces",
        "name": "hatchly.api.linked-spaces.get"
    },
    {
        "uri": "admin\/api\/locations\/{space}\/linked-spaces\/link-space",
        "name": "hatchly.api.linked-spaces.link-space"
    },
    {
        "uri": "admin\/api\/locations\/{space}\/linked-spaces\/unlink-space",
        "name": "hatchly.api.linked-spaces.unlink-space"
    },
    {
        "uri": "admin\/api\/locations\/{space}\/linked-spaces\/search",
        "name": "hatchly.api.linked-spaces.search"
    },
    {
        "uri": "admin\/api\/locations\/{space}\/seo",
        "name": "hatchly.api.seo.update"
    },
    {
        "uri": "admin\/api\/locations\/{spaceId}\/save-default-cashless-tab",
        "name": "hatchly.api.spaces.save-default-cashless-tab"
    },
    {
        "uri": "admin\/api\/locations\/{spaceId}\/get-cashless-details",
        "name": "hatchly.api.spaces.get-cashless-details"
    },
    {
        "uri": "admin\/api\/locations\/{space}\/save-force-noindex",
        "name": "hatchly.api.space-info.save-force-noindex"
    },
    {
        "uri": "admin\/api\/locations\/{space}\/save-country",
        "name": "hatchly.api.spaces.save-country"
    },
    {
        "uri": "admin\/api\/locations\/{space}\/vrn-update-restrictions",
        "name": "hatchly.api.spaces.vrn-update-restrictions"
    },
    {
        "uri": "admin\/api\/locations\/{space}\/update-roadworthy-vehicle-settings",
        "name": "hatchly.api.spaces.update-roadworthy-vehicle-settings"
    },
    {
        "uri": "admin\/api\/locations\/{space}\/disable-paypal-options",
        "name": "hatchly.api.spaces.disable-paypal-options"
    },
    {
        "uri": "admin\/api\/locations\/{spaceId}\/update-space-payout-fee-percentage",
        "name": "hatchly.api.space-info.update-space-payout-fee-percentage"
    },
    {
        "uri": "admin\/api\/locations\/{space}\/airport-code",
        "name": "hatchly.api.spaces.airport-code"
    },
    {
        "uri": "admin\/api\/locations\/check-can-move-space-to-new-owner",
        "name": "hatchly.api.space-info.check-can-move-space-to-new-owner"
    },
    {
        "uri": "admin\/api\/locations\/{space}\/toggle-messaging",
        "name": "hatchly.api.spaces.toggle-messaging"
    },
    {
        "uri": "admin\/api\/locations\/{space}\/handle-guest-validation",
        "name": "hatchly.api.spaces.toggle-handle-guest-validation"
    },
    {
        "uri": "admin\/api\/locations\/{space}\/pricing\/toggle-service-fee-rounding-enabled",
        "name": "hatchly.api.space-info.pricing.toggle-service-fee-rounding-enabled"
    },
    {
        "uri": "admin\/api\/bookings\/{booking}\/post-booking-info",
        "name": "hatchly.api.bookings.post-booking-info"
    },
    {
        "uri": "admin\/api\/bookings\/{booking}\/send-st-vat-receipt",
        "name": "hatchly.api.bookings.send-st-vat-receipt"
    },
    {
        "uri": "admin\/api\/bookings\/{column}\/summary-total",
        "name": "hatchly.api.bookings.summary-total"
    },
    {
        "uri": "admin\/api\/bookings\/bulk-cancel\/{spaceId}\/get-view-data",
        "name": "hatchly.api.bookings.bulk-cancel.get-view-data"
    },
    {
        "uri": "admin\/api\/bookings\/bulk-cancel\/{spaceId}\/cancel",
        "name": "hatchly.api.bookings.bulk-cancel.cancel"
    },
    {
        "uri": "admin\/api\/bookings\/{booking}\/season-to-monthly\/convert",
        "name": "hatchly.api.bookings.season-to-monthly.convert"
    },
    {
        "uri": "admin\/api\/bookings\/{booking}\/season-to-monthly\/terminate",
        "name": "hatchly.api.bookings.season-to-monthly.terminate"
    },
    {
        "uri": "admin\/api\/bookings\/{booking}\/season-to-monthly\/notify",
        "name": "hatchly.api.bookings.season-to-monthly.notify"
    },
    {
        "uri": "admin\/api\/horizon-promotions\/get-barcodes",
        "name": "hatchly.api.horizon-promotions.get-barcodes"
    },
    {
        "uri": "admin\/api\/horizon-promotions\/store",
        "name": "hatchly.api.horizon-promotions.store"
    },
    {
        "uri": "admin\/api\/horizon-promotions\/{promotion}\/update",
        "name": "hatchly.api.horizon-promotions.update"
    },
    {
        "uri": "admin\/api\/horizon-promotions\/{promotion}\/delete",
        "name": "hatchly.api.horizon-promotions.delete"
    },
    {
        "uri": "admin\/api\/horizon-promotions\/enable",
        "name": "hatchly.api.horizon-promotions.enable"
    },
    {
        "uri": "admin\/api\/auto-pay\/bookings\/{bookingId}\/concurrent-bookings",
        "name": "hatchly.api.auto-pay.bookings.concurrent-bookings"
    },
    {
        "uri": "admin\/api\/auto-pay\/bookings\/complete\/{bookingId}\/complete\/get-payment-details",
        "name": "hatchly.api.auto-pay.bookings.complete.get-payment-details"
    },
    {
        "uri": "admin\/api\/auto-pay\/bookings\/complete\/{bookingId}\/complete",
        "name": "hatchly.api.auto-pay.bookings.complete"
    },
    {
        "uri": "admin\/api\/auto-pay\/whitelist\/get-tariff-boards",
        "name": "hatchly.api.auto-pay.whitelist.get-tariff-boards"
    },
    {
        "uri": "admin\/api\/auto-pay\/outstanding-payments\/{paymentId}\/mark-as-paid",
        "name": "hatchly.api.auto-pay.outstanding-payments.mark-as-paid"
    },
    {
        "uri": "admin\/api\/auto-pay\/outstanding-payments\/{paymentId}",
        "name": "hatchly.api.auto-pay.outstanding-payments.get-payment"
    },
    {
        "uri": "admin\/api\/{space}\/custom-text\/kiosk-custom-text-enabled",
        "name": "hatchly.api.kiosk-config.kiosk-custom-text-enabled"
    },
    {
        "uri": "admin\/api\/{space}\/custom-text\/kiosk-custom-text",
        "name": "hatchly.api.kiosk-config.kiosk-custom-text"
    },
    {
        "uri": "admin\/api\/{space}\/custom-voucher\/kiosk-custom-voucher-enabled",
        "name": "hatchly.api.kiosk-config.kiosk-custom-voucher-enabled"
    },
    {
        "uri": "admin\/api\/{space}\/custom-voucher\/kiosk-custom-voucher",
        "name": "hatchly.api.kiosk-config.kiosk-custom-voucher"
    },
    {
        "uri": "admin\/api\/finance\/incoming\/subscriptions\/bulk-mark-as-paid",
        "name": "hatchly.api.finance.incoming.subscriptions.bulk-mark-as-paid"
    },
    {
        "uri": "admin\/api\/finance\/space-owners\/remittance-settings\/get-remittance-settings",
        "name": "hatchly.api.finance.space-owners.remittance-settings.get-remittance-settings"
    },
    {
        "uri": "admin\/api\/finance\/space-owners\/remittance-settings\/custom-commission",
        "name": "hatchly.api.finance.space-owners.remittance-settings.get-custom-commission"
    },
    {
        "uri": "admin\/api\/finance\/space-owners\/remittance-settings\/save\/general",
        "name": "hatchly.api.finance.space-owners.remittance-settings.save.general"
    },
    {
        "uri": "admin\/api\/finance\/space-owners\/remittance-settings\/save\/recurring-fees",
        "name": "hatchly.api.finance.space-owners.remittance-settings.save.recurring-fees"
    },
    {
        "uri": "admin\/api\/finance\/space-owners\/remittance-settings\/save\/custom-commission",
        "name": "hatchly.api.finance.space-owners.remittance-settings.save.custom-commission"
    },
    {
        "uri": "admin\/api\/finance\/space-owners\/remittance-settings\/custom-commission\/{commissionItem}",
        "name": "hatchly.api.finance.space-owners.remittance-settings.delete-custom-commission"
    },
    {
        "uri": "admin\/api\/finance\/space-owners\/custom-ledger\/get-adjustment-form-data",
        "name": "hatchly.api.finance.space-owners.custom-ledger.get-adjustment-form-data"
    },
    {
        "uri": "admin\/api\/finance\/space-owners\/custom-ledger\/store",
        "name": "hatchly.api.finance.space-owners.custom-ledger.store"
    },
    {
        "uri": "admin\/api\/finance\/space-owners\/custom-ledger\/{ledgerItem}\/update",
        "name": "hatchly.api.finance.space-owners.custom-ledger.update"
    },
    {
        "uri": "admin\/api\/finance\/space-owners\/private-payments\/get-paid-totals",
        "name": "hatchly.api.finance.space-owners.private-payments.get-paid-totals"
    },
    {
        "uri": "admin\/api\/finance\/space-owners\/private-payments\/get-potential-fraud",
        "name": "hatchly.api.finance.space-owners.private-payments.get-potential-fraud"
    },
    {
        "uri": "admin\/api\/finance\/space-owners\/private-payments\/get-potential-fraud-space-owners",
        "name": "hatchly.api.finance.space-owners.private-payments.get-potential-fraud-space-owners"
    },
    {
        "uri": "admin\/api\/finance\/space-owners\/private-payments\/get-potential-fraud-transactions",
        "name": "hatchly.api.finance.space-owners.private-payments.get-potential-fraud-transactions"
    },
    {
        "uri": "admin\/api\/finance\/space-owners\/private-payments\/mark-as-paid",
        "name": "hatchly.api.finance.space-owners.private-payments.mark-as-paid"
    },
    {
        "uri": "admin\/api\/finance\/space-owners\/private-payments\/check-marked-paid",
        "name": "hatchly.api.finance.space-owners.private-payments.check-marked-paid"
    },
    {
        "uri": "admin\/api\/finance\/space-owners\/private-payments\/mark-bank-rejected",
        "name": "hatchly.api.finance.space-owners.private-payments.mark-bank-rejected"
    },
    {
        "uri": "admin\/api\/finance\/space-owners\/private-payments\/mark-as-payable",
        "name": "hatchly.api.finance.space-owners.private-payments.mark-as-payable"
    },
    {
        "uri": "admin\/api\/finance\/space-owners\/private-payments\/file-details",
        "name": "hatchly.api.finance.space-owners.private-payments.get-file-details"
    },
    {
        "uri": "admin\/api\/finance\/space-owners\/private-payments\/resolve-potential-fraud",
        "name": "hatchly.api.finance.space-owners.private-payments.resolve-potential-fraud"
    },
    {
        "uri": "admin\/api\/finance\/space-owners\/private-payments\/trigger-export",
        "name": "hatchly.api.finance.space-owners.private-payments.trigger-export"
    },
    {
        "uri": "admin\/api\/finance\/space-owners\/private-payments\/account-value",
        "name": "hatchly.api.finance.space-owners.private-payments.get-account-value"
    },
    {
        "uri": "admin\/api\/finance\/space-owners\/private-payments\/trigger-calculate-account-value",
        "name": "hatchly.api.finance.space-owners.private-payments.trigger-calculate-account-value"
    },
    {
        "uri": "admin\/api\/finance\/space-owners\/corporate-remittances\/trigger-corporate-remittance-job",
        "name": "hatchly.api.finance.space-owners.corporate-remittances.trigger-corporate-remittance-job"
    },
    {
        "uri": "admin\/api\/finance\/space-owners\/service-common\/currency-conversion-rates",
        "name": "hatchly.api.finance.space-owners.service-common.get-currency-conversion-rates"
    },
    {
        "uri": "admin\/api\/finance\/space-owners\/service-common\/currency-conversion-rates",
        "name": "hatchly.api.finance.space-owners.service-common.submit-currency-conversion-rates"
    },
    {
        "uri": "admin\/api\/finance\/space-owners\/service-common\/task-status\/{taskId}",
        "name": "hatchly.api.finance.space-owners.service-common.get-task-status"
    },
    {
        "uri": "admin\/api\/reviews\/transfer-reviews",
        "name": "hatchly.api.reviews.transfer"
    },
    {
        "uri": "admin\/api\/reservation-fees\/settings",
        "name": "hatchly.api.reservation-fees.settings"
    },
    {
        "uri": "admin\/api\/reservation-fees\/pricing",
        "name": "hatchly.api.reservation-fees.pricing"
    },
    {
        "uri": "admin\/api\/arrangement-fees\/settings",
        "name": "hatchly.api.arrangement-fees.settings"
    },
    {
        "uri": "admin\/api\/arrangement-fees\/pricing\/monthly",
        "name": "hatchly.api.arrangement-fees.pricing.monthly"
    },
    {
        "uri": "admin\/api\/arrangement-fees\/pricing\/season",
        "name": "hatchly.api.arrangement-fees.pricing.season"
    },
    {
        "uri": "api\/locations\/{space}\/save-post-pay-settings",
        "name": "hatchly.api.space-info.save-post-pay-settings"
    },
    {
        "uri": "api\/locations\/{spaceId}\/booking-count",
        "name": "hatchly.api.space-info.booking-count"
    },
    {
        "uri": "api\/locations\/booked-count",
        "name": "hatchly.api.spaces.booked-count"
    },
    {
        "uri": "api\/locations\/{space}\/save-kiosk-durations",
        "name": "hatchly.api.space-info.save-kiosk-durations"
    },
    {
        "uri": "api\/locations\/{spaceId}\/save-service-fees",
        "name": "hatchly.api.space-info.save-service-fees"
    },
    {
        "uri": "api\/locations\/{spaceId}\/skip-availability-check-cashless",
        "name": "hatchly.api.space-info.skip-availability-check-cashless"
    },
    {
        "uri": "api\/locations\/{spaceId}\/pricing\/save-tariff-pricing-model",
        "name": "hatchly.api.space-info.pricing.save-tariff-pricing-model"
    },
    {
        "uri": "api\/locations\/{spaceId}\/pricing\/save-post-max-tariff-model",
        "name": "hatchly.api.space-info.pricing.save-post-max-tariff-model"
    },
    {
        "uri": "api\/locations\/{spaceId}\/pricing\/save-short-term",
        "name": "hatchly.api.space-info.pricing.save-short-term"
    },
    {
        "uri": "api\/locations\/{spaceId}\/pricing\/save-kiosk-service-fees",
        "name": "hatchly.api.space-info.pricing.save-kiosk-service-fees"
    },
    {
        "uri": "api\/locations\/{spaceId}\/pricing\/save-tariff-board",
        "name": "hatchly.api.space-info.pricing.save-tariff-board"
    },
    {
        "uri": "api\/locations\/{spaceId}\/pricing\/save-tariff-board-order",
        "name": "hatchly.api.space-info.pricing.save-tariff-board-order"
    },
    {
        "uri": "api\/locations\/{spaceId}\/pricing\/delete-tariff-board\/{boardId}",
        "name": "hatchly.api.space-info.pricing.delete-tariff-board"
    },
    {
        "uri": "api\/locations\/{spaceId}\/pricing\/get-rate-card-logs",
        "name": "hatchly.api.space-info.pricing.get-rate-card-logs"
    },
    {
        "uri": "api\/locations\/{spaceId}\/pricing\/save-rate-card",
        "name": "hatchly.api.space-info.pricing.save-rate-card"
    },
    {
        "uri": "api\/locations\/{spaceId}\/pricing\/delete-rate-card\/{rateCard}",
        "name": "hatchly.api.space-info.pricing.delete-rate-card"
    },
    {
        "uri": "api\/locations\/{space}\/pricing\/save-season-pricing",
        "name": "hatchly.api.space-info.pricing.save-season-pricing"
    },
    {
        "uri": "api\/locations\/ratecard\/{rateCard}\/get-rate-card-items\/{rateCardType}",
        "name": "hatchly.api.space-info.pricing.get-rate-card-items"
    },
    {
        "uri": "api\/locations\/ratecard\/{rateCard}\/add-rate-card-items\/{rateCardType}",
        "name": "hatchly.api.space-info.pricing.add-rate-card-item"
    },
    {
        "uri": "api\/locations\/ratecard\/{rateCard}\/search-rate-card-items\/{rateCardType}\/{item}",
        "name": "hatchly.api.space-info.pricing.search-rate-card-item"
    },
    {
        "uri": "api\/locations\/ratecard\/{rateCard}\/remove-rate-card-items\/{rateCardType}\/{item}",
        "name": "hatchly.api.space-info.pricing.remove-rate-card-item"
    },
    {
        "uri": "api\/locations\/ratecard\/{rateCard}\/save-tariff-pricing-model",
        "name": "hatchly.api.space-info.pricing.rate-card.save-tariff-pricing-model"
    },
    {
        "uri": "api\/locations\/ratecard\/{rateCard}\/save-post-max-tariff-model",
        "name": "hatchly.api.space-info.pricing.rate-card.save-post-max-tariff-model"
    },
    {
        "uri": "api\/locations\/{spaceId}\/dynamic-pricing\/get-for-date",
        "name": "hatchly.api.space.dynamic-pricing.get-for-date"
    },
    {
        "uri": "api\/locations\/{spaceId}\/dynamic-pricing\/save",
        "name": "hatchly.api.space-info.dynamic-pricing.save"
    },
    {
        "uri": "api\/locations\/{spaceId}\/save-auto-pay",
        "name": "hatchly.api.spaces.save-auto-pay"
    },
    {
        "uri": "api\/locations\/{space}\/linked-spaces",
        "name": "hatchly.api.linked-spaces.get"
    },
    {
        "uri": "api\/locations\/{space}\/linked-spaces\/link-space",
        "name": "hatchly.api.linked-spaces.link-space"
    },
    {
        "uri": "api\/locations\/{space}\/linked-spaces\/unlink-space",
        "name": "hatchly.api.linked-spaces.unlink-space"
    },
    {
        "uri": "api\/locations\/{space}\/linked-spaces\/search",
        "name": "hatchly.api.linked-spaces.search"
    },
    {
        "uri": "api\/locations\/{space}\/seo",
        "name": "hatchly.api.seo.update"
    },
    {
        "uri": "api\/locations\/{spaceId}\/save-default-cashless-tab",
        "name": "hatchly.api.spaces.save-default-cashless-tab"
    },
    {
        "uri": "api\/locations\/{spaceId}\/get-cashless-details",
        "name": "hatchly.api.spaces.get-cashless-details"
    },
    {
        "uri": "api\/locations\/{space}\/save-force-noindex",
        "name": "hatchly.api.space-info.save-force-noindex"
    },
    {
        "uri": "api\/locations\/{space}\/save-country",
        "name": "hatchly.api.spaces.save-country"
    },
    {
        "uri": "api\/locations\/{space}\/vrn-update-restrictions",
        "name": "hatchly.api.spaces.vrn-update-restrictions"
    },
    {
        "uri": "api\/locations\/{space}\/update-roadworthy-vehicle-settings",
        "name": "hatchly.api.spaces.update-roadworthy-vehicle-settings"
    },
    {
        "uri": "api\/locations\/{space}\/disable-paypal-options",
        "name": "hatchly.api.spaces.disable-paypal-options"
    },
    {
        "uri": "api\/locations\/{spaceId}\/update-space-payout-fee-percentage",
        "name": "hatchly.api.space-info.update-space-payout-fee-percentage"
    },
    {
        "uri": "api\/locations\/{space}\/airport-code",
        "name": "hatchly.api.spaces.airport-code"
    },
    {
        "uri": "api\/locations\/check-can-move-space-to-new-owner",
        "name": "hatchly.api.space-info.check-can-move-space-to-new-owner"
    },
    {
        "uri": "api\/locations\/{space}\/toggle-messaging",
        "name": "hatchly.api.spaces.toggle-messaging"
    },
    {
        "uri": "api\/locations\/{space}\/handle-guest-validation",
        "name": "hatchly.api.spaces.toggle-handle-guest-validation"
    },
    {
        "uri": "api\/locations\/{space}\/pricing\/toggle-service-fee-rounding-enabled",
        "name": "hatchly.api.space-info.pricing.toggle-service-fee-rounding-enabled"
    },
    {
        "uri": "api\/bookings\/{booking}\/post-booking-info",
        "name": "hatchly.api.bookings.post-booking-info"
    },
    {
        "uri": "api\/bookings\/{booking}\/send-st-vat-receipt",
        "name": "hatchly.api.bookings.send-st-vat-receipt"
    },
    {
        "uri": "api\/bookings\/{column}\/summary-total",
        "name": "hatchly.api.bookings.summary-total"
    },
    {
        "uri": "api\/bookings\/bulk-cancel\/{spaceId}\/get-view-data",
        "name": "hatchly.api.bookings.bulk-cancel.get-view-data"
    },
    {
        "uri": "api\/bookings\/bulk-cancel\/{spaceId}\/cancel",
        "name": "hatchly.api.bookings.bulk-cancel.cancel"
    },
    {
        "uri": "api\/bookings\/{booking}\/season-to-monthly\/convert",
        "name": "hatchly.api.bookings.season-to-monthly.convert"
    },
    {
        "uri": "api\/bookings\/{booking}\/season-to-monthly\/terminate",
        "name": "hatchly.api.bookings.season-to-monthly.terminate"
    },
    {
        "uri": "api\/bookings\/{booking}\/season-to-monthly\/notify",
        "name": "hatchly.api.bookings.season-to-monthly.notify"
    },
    {
        "uri": "api\/horizon-promotions\/get-barcodes",
        "name": "hatchly.api.horizon-promotions.get-barcodes"
    },
    {
        "uri": "api\/horizon-promotions\/store",
        "name": "hatchly.api.horizon-promotions.store"
    },
    {
        "uri": "api\/horizon-promotions\/{promotion}\/update",
        "name": "hatchly.api.horizon-promotions.update"
    },
    {
        "uri": "api\/horizon-promotions\/{promotion}\/delete",
        "name": "hatchly.api.horizon-promotions.delete"
    },
    {
        "uri": "api\/horizon-promotions\/enable",
        "name": "hatchly.api.horizon-promotions.enable"
    },
    {
        "uri": "api\/auto-pay\/bookings\/{bookingId}\/concurrent-bookings",
        "name": "hatchly.api.auto-pay.bookings.concurrent-bookings"
    },
    {
        "uri": "api\/auto-pay\/bookings\/complete\/{bookingId}\/complete\/get-payment-details",
        "name": "hatchly.api.auto-pay.bookings.complete.get-payment-details"
    },
    {
        "uri": "api\/auto-pay\/bookings\/complete\/{bookingId}\/complete",
        "name": "hatchly.api.auto-pay.bookings.complete"
    },
    {
        "uri": "api\/auto-pay\/whitelist\/get-tariff-boards",
        "name": "hatchly.api.auto-pay.whitelist.get-tariff-boards"
    },
    {
        "uri": "api\/auto-pay\/outstanding-payments\/{paymentId}\/mark-as-paid",
        "name": "hatchly.api.auto-pay.outstanding-payments.mark-as-paid"
    },
    {
        "uri": "api\/auto-pay\/outstanding-payments\/{paymentId}",
        "name": "hatchly.api.auto-pay.outstanding-payments.get-payment"
    },
    {
        "uri": "api\/{space}\/custom-text\/kiosk-custom-text-enabled",
        "name": "hatchly.api.kiosk-config.kiosk-custom-text-enabled"
    },
    {
        "uri": "api\/{space}\/custom-text\/kiosk-custom-text",
        "name": "hatchly.api.kiosk-config.kiosk-custom-text"
    },
    {
        "uri": "api\/{space}\/custom-voucher\/kiosk-custom-voucher-enabled",
        "name": "hatchly.api.kiosk-config.kiosk-custom-voucher-enabled"
    },
    {
        "uri": "api\/{space}\/custom-voucher\/kiosk-custom-voucher",
        "name": "hatchly.api.kiosk-config.kiosk-custom-voucher"
    },
    {
        "uri": "api\/finance\/incoming\/subscriptions\/bulk-mark-as-paid",
        "name": "hatchly.api.finance.incoming.subscriptions.bulk-mark-as-paid"
    },
    {
        "uri": "api\/finance\/space-owners\/remittance-settings\/get-remittance-settings",
        "name": "hatchly.api.finance.space-owners.remittance-settings.get-remittance-settings"
    },
    {
        "uri": "api\/finance\/space-owners\/remittance-settings\/custom-commission",
        "name": "hatchly.api.finance.space-owners.remittance-settings.get-custom-commission"
    },
    {
        "uri": "api\/finance\/space-owners\/remittance-settings\/save\/general",
        "name": "hatchly.api.finance.space-owners.remittance-settings.save.general"
    },
    {
        "uri": "api\/finance\/space-owners\/remittance-settings\/save\/recurring-fees",
        "name": "hatchly.api.finance.space-owners.remittance-settings.save.recurring-fees"
    },
    {
        "uri": "api\/finance\/space-owners\/remittance-settings\/save\/custom-commission",
        "name": "hatchly.api.finance.space-owners.remittance-settings.save.custom-commission"
    },
    {
        "uri": "api\/finance\/space-owners\/remittance-settings\/custom-commission\/{commissionItem}",
        "name": "hatchly.api.finance.space-owners.remittance-settings.delete-custom-commission"
    },
    {
        "uri": "api\/finance\/space-owners\/custom-ledger\/get-adjustment-form-data",
        "name": "hatchly.api.finance.space-owners.custom-ledger.get-adjustment-form-data"
    },
    {
        "uri": "api\/finance\/space-owners\/custom-ledger\/store",
        "name": "hatchly.api.finance.space-owners.custom-ledger.store"
    },
    {
        "uri": "api\/finance\/space-owners\/custom-ledger\/{ledgerItem}\/update",
        "name": "hatchly.api.finance.space-owners.custom-ledger.update"
    },
    {
        "uri": "api\/finance\/space-owners\/private-payments\/get-paid-totals",
        "name": "hatchly.api.finance.space-owners.private-payments.get-paid-totals"
    },
    {
        "uri": "api\/finance\/space-owners\/private-payments\/get-potential-fraud",
        "name": "hatchly.api.finance.space-owners.private-payments.get-potential-fraud"
    },
    {
        "uri": "api\/finance\/space-owners\/private-payments\/get-potential-fraud-space-owners",
        "name": "hatchly.api.finance.space-owners.private-payments.get-potential-fraud-space-owners"
    },
    {
        "uri": "api\/finance\/space-owners\/private-payments\/get-potential-fraud-transactions",
        "name": "hatchly.api.finance.space-owners.private-payments.get-potential-fraud-transactions"
    },
    {
        "uri": "api\/finance\/space-owners\/private-payments\/mark-as-paid",
        "name": "hatchly.api.finance.space-owners.private-payments.mark-as-paid"
    },
    {
        "uri": "api\/finance\/space-owners\/private-payments\/check-marked-paid",
        "name": "hatchly.api.finance.space-owners.private-payments.check-marked-paid"
    },
    {
        "uri": "api\/finance\/space-owners\/private-payments\/mark-bank-rejected",
        "name": "hatchly.api.finance.space-owners.private-payments.mark-bank-rejected"
    },
    {
        "uri": "api\/finance\/space-owners\/private-payments\/mark-as-payable",
        "name": "hatchly.api.finance.space-owners.private-payments.mark-as-payable"
    },
    {
        "uri": "api\/finance\/space-owners\/private-payments\/file-details",
        "name": "hatchly.api.finance.space-owners.private-payments.get-file-details"
    },
    {
        "uri": "api\/finance\/space-owners\/private-payments\/resolve-potential-fraud",
        "name": "hatchly.api.finance.space-owners.private-payments.resolve-potential-fraud"
    },
    {
        "uri": "api\/finance\/space-owners\/private-payments\/trigger-export",
        "name": "hatchly.api.finance.space-owners.private-payments.trigger-export"
    },
    {
        "uri": "api\/finance\/space-owners\/private-payments\/account-value",
        "name": "hatchly.api.finance.space-owners.private-payments.get-account-value"
    },
    {
        "uri": "api\/finance\/space-owners\/private-payments\/trigger-calculate-account-value",
        "name": "hatchly.api.finance.space-owners.private-payments.trigger-calculate-account-value"
    },
    {
        "uri": "api\/finance\/space-owners\/corporate-remittances\/trigger-corporate-remittance-job",
        "name": "hatchly.api.finance.space-owners.corporate-remittances.trigger-corporate-remittance-job"
    },
    {
        "uri": "api\/finance\/space-owners\/service-common\/currency-conversion-rates",
        "name": "hatchly.api.finance.space-owners.service-common.get-currency-conversion-rates"
    },
    {
        "uri": "api\/finance\/space-owners\/service-common\/currency-conversion-rates",
        "name": "hatchly.api.finance.space-owners.service-common.submit-currency-conversion-rates"
    },
    {
        "uri": "api\/finance\/space-owners\/service-common\/task-status\/{taskId}",
        "name": "hatchly.api.finance.space-owners.service-common.get-task-status"
    },
    {
        "uri": "api\/reviews\/transfer-reviews",
        "name": "hatchly.api.reviews.transfer"
    },
    {
        "uri": "api\/reservation-fees\/settings",
        "name": "hatchly.api.reservation-fees.settings"
    },
    {
        "uri": "api\/reservation-fees\/pricing",
        "name": "hatchly.api.reservation-fees.pricing"
    },
    {
        "uri": "api\/arrangement-fees\/settings",
        "name": "hatchly.api.arrangement-fees.settings"
    },
    {
        "uri": "api\/arrangement-fees\/pricing\/monthly",
        "name": "hatchly.api.arrangement-fees.pricing.monthly"
    },
    {
        "uri": "api\/arrangement-fees\/pricing\/season",
        "name": "hatchly.api.arrangement-fees.pricing.season"
    },
    {
        "uri": "_ajax\/view_booking\/{id}",
        "name": "account.ajax.get_booking"
    },
    {
        "uri": "resend-sms-verification",
        "name": "account.resend-sms-verification"
    },
    {
        "uri": "verify-sms",
        "name": "account.verify-sms"
    },
    {
        "uri": "resend-email-verification",
        "name": "account.resend-email-verification"
    },
    {
        "uri": "profile",
        "name": "account.profile"
    },
    {
        "uri": "tenant\/bookings\/{bookingId}\/extend\/admin",
        "name": "ajax.account.tenant.extend-admin"
    },
    {
        "uri": "tenant\/reservations\/{bookingId}\/cancel",
        "name": "account.tenant.reservations.cancel-booking"
    },
    {
        "uri": "tenant\/reservations\/{bookingId}\/change-vehicle",
        "name": "account.tenant.reservations.change-vehicle"
    },
    {
        "uri": "tenant\/reservations\/{bookingId}\/pdf\/{download?}",
        "name": "account.tenant.reservations.download-pdf"
    },
    {
        "uri": "tenant\/reservations\/{bookingId}\/pdf\/email",
        "name": "account.tenant.reservations.email-pdf"
    },
    {
        "uri": "tenant\/payments\/{trackerId}\/pdf",
        "name": "account.tenant.payments.download-lt-pdf"
    },
    {
        "uri": "tenant\/reservations\/{bookingId}\/resend-booking-confirmation",
        "name": "account.tenant.reservations.resend-booking-confirmation"
    },
    {
        "uri": "landlord\/listings\/{id}\/disable",
        "name": "account.landlord.spaces.disable"
    },
    {
        "uri": "landlord\/listings\/{id}\/delete",
        "name": "account.landlord.spaces.delete"
    },
    {
        "uri": "landlord\/listings\/{id}\/enable",
        "name": "account.landlord.spaces.enable"
    },
    {
        "uri": "landlord\/listings\/{id}\/enable",
        "name": "account.landlord.spaces.enable"
    },
    {
        "uri": "landlord\/listings\/{id}\/availability-enable",
        "name": "account.landlord.spaces.availability-enable"
    },
    {
        "uri": "landlord\/listings\/{id}\/availability-disable",
        "name": "account.landlord.spaces.availability-disable"
    },
    {
        "uri": "oauth\/authorize",
        "name": "passport.authorizations.authorize"
    },
    {
        "uri": "oauth\/authorize",
        "name": "passport.authorizations.approve"
    },
    {
        "uri": "oauth\/authorize",
        "name": "passport.authorizations.deny"
    },
    {
        "uri": "oauth\/token",
        "name": "passport.token"
    },
    {
        "uri": "oauth\/tokens",
        "name": "passport.tokens.index"
    },
    {
        "uri": "oauth\/tokens\/{token_id}",
        "name": "passport.tokens.destroy"
    },
    {
        "uri": "oauth\/token\/refresh",
        "name": "passport.token.refresh"
    },
    {
        "uri": "oauth\/clients",
        "name": "passport.clients.index"
    },
    {
        "uri": "oauth\/clients",
        "name": "passport.clients.store"
    },
    {
        "uri": "oauth\/clients\/{client_id}",
        "name": "passport.clients.update"
    },
    {
        "uri": "oauth\/clients\/{client_id}",
        "name": "passport.clients.destroy"
    },
    {
        "uri": "oauth\/scopes",
        "name": "passport.scopes.index"
    },
    {
        "uri": "oauth\/personal-access-tokens",
        "name": "passport.personal.tokens.index"
    },
    {
        "uri": "oauth\/personal-access-tokens",
        "name": "passport.personal.tokens.store"
    },
    {
        "uri": "oauth\/personal-access-tokens\/{token_id}",
        "name": "passport.personal.tokens.destroy"
    },
    {
        "uri": "notes\/notes-about-owner\/{id}\/{referrer?}",
        "name": "hatchly.notes.notes-about-owner.index"
    },
    {
        "uri": "notes\/notes-about-owner\/{id}",
        "name": "hatchly.notes.notes-about-owner.store"
    },
    {
        "uri": "notes\/notes-about-owner\/{id}\/{note_id}",
        "name": "hatchly.notes.notes-about-owner.delete"
    },
    {
        "uri": "api\/notes\/notes-about-owner\/{id}\/{amount}",
        "name": "hatchly.api.notes.notes-about-owner.index"
    },
    {
        "uri": "api\/notes\/notes-about-owner\/{id}",
        "name": "hatchly.api.notes.notes-about-owner.store"
    },
    {
        "uri": "api\/notes\/notes-about-owner\/{id}\/{note_id}",
        "name": "hatchly.api.notes.notes-about-owner.delete"
    },
    {
        "uri": "locations",
        "name": "hatchly.spaces.index"
    },
    {
        "uri": "locations\/auto-pay\/whitelist\/export-data",
        "name": "hatchly.spaces.autopay.whitelist.export-data"
    },
    {
        "uri": "locations\/waiting-for-approval",
        "name": "hatchly.spaces.waiting-for-approval"
    },
    {
        "uri": "locations\/waiting-for-follow-up",
        "name": "hatchly.spaces.waiting-for-follow-up"
    },
    {
        "uri": "locations\/export",
        "name": "hatchly.spaces.export"
    },
    {
        "uri": "locations\/{spaceId}\/schedule-action",
        "name": "hatchly.spaces.store-schedule-action"
    },
    {
        "uri": "locations\/{spaceId}\/schedule-action\/{id}",
        "name": "hatchly.spaces.update-scheduled-action"
    },
    {
        "uri": "locations\/{spaceId}\/schedule-action\/{id}",
        "name": "hatchly.spaces.delete-scheduled-action"
    },
    {
        "uri": "locations\/imports",
        "name": "hatchly.spaces.imports"
    },
    {
        "uri": "locations\/bulk-import",
        "name": "hatchly.spaces.imports.bulk-import"
    },
    {
        "uri": "locations\/bulk-import-template",
        "name": "hatchly.spaces.imports.bulk-import-template"
    },
    {
        "uri": "locations\/bulk-disable",
        "name": "hatchly.spaces.imports.bulk-disable"
    },
    {
        "uri": "locations\/bulk-update-post-booking-info",
        "name": "hatchly.spaces.imports.bulk-update-post-booking-info"
    },
    {
        "uri": "locations\/bulk-update-pricing",
        "name": "hatchly.spaces.imports.bulk-update-pricing"
    },
    {
        "uri": "locations\/bulk-update-season-pricing",
        "name": "hatchly.spaces.imports.bulk-update-season-pricing"
    },
    {
        "uri": "locations\/bulk-update-dynamic-pricing",
        "name": "hatchly.spaces.imports.bulk-update-dynamic-pricing"
    },
    {
        "uri": "locations\/export-failed-import-csv\/{filename}",
        "name": "hatchly.spaces.export-failed-import"
    },
    {
        "uri": "locations\/show-id",
        "name": "hatchly.spaces.show-id"
    },
    {
        "uri": "locations\/{id}\/info",
        "name": "hatchly.spaces.info"
    },
    {
        "uri": "locations\/{id}\/debug",
        "name": "hatchly.spaces.debug"
    },
    {
        "uri": "locations\/{space}\/kiosk",
        "name": "hatchly.spaces.kiosk"
    },
    {
        "uri": "locations\/{space}\/kiosk",
        "name": "hatchly.spaces.kiosk"
    },
    {
        "uri": "locations\/{space}\/kiosk\/create",
        "name": "hatchly.spaces.kiosk.create"
    },
    {
        "uri": "locations\/{space}\/kiosk\/create",
        "name": "hatchly.spaces.kiosk.create"
    },
    {
        "uri": "locations\/{space}\/kiosk\/tariff-notes",
        "name": "hatchly.spaces.kiosk.tariff-notes"
    },
    {
        "uri": "locations\/{space}\/{kiosk}\/kiosk\/edit",
        "name": "hatchly.spaces.kiosk.edit"
    },
    {
        "uri": "locations\/{space}\/{kiosk}\/kiosk\/edit",
        "name": "hatchly.spaces.kiosk.edit"
    },
    {
        "uri": "locations\/{space}\/{kiosk}\/kiosk\/delete",
        "name": "hatchly.spaces.kiosk.delete"
    },
    {
        "uri": "locations\/{space}\/guest-validation",
        "name": "hatchly.spaces.guest-validation"
    },
    {
        "uri": "locations\/{space}\/guest-validation\/config",
        "name": "hatchly.spaces.guest-validation.config"
    },
    {
        "uri": "locations\/{space}\/guest-validation\/config\/update",
        "name": "hatchly.spaces.guest-validation.config.update"
    },
    {
        "uri": "locations\/{space}\/guest-validation\/config\/save",
        "name": "hatchly.spaces.guest-validation.config.save"
    },
    {
        "uri": "locations\/{space}\/guest-validation\/qr-code\/{code}",
        "name": "hatchly.spaces.guest-validation.qr-code"
    },
    {
        "uri": "locations\/{space}\/guest-validation\/codes",
        "name": "hatchly.spaces.guest-validation.codes"
    },
    {
        "uri": "locations\/{space_id}\/pricing",
        "name": "hatchly.spaces.pricing"
    },
    {
        "uri": "locations\/{space}\/autopay-fields",
        "name": "hatchly.pricing.autopay-fields"
    },
    {
        "uri": "locations\/{space}\/linked-spaces",
        "name": "hatchly.spaces.linked-spaces"
    },
    {
        "uri": "locations\/{space}\/seo",
        "name": "hatchly.spaces.seo"
    },
    {
        "uri": "locations\/{id}\/force-index",
        "name": "hatchly.spaces.force-index"
    },
    {
        "uri": "locations\/{id}\/info",
        "name": "hatchly.spaces.info"
    },
    {
        "uri": "locations\/{id}\/set-space-type",
        "name": "hatchly.spaces.set-space-type"
    },
    {
        "uri": "locations\/{space}\/set-sub-space-type",
        "name": "hatchly.spaces.set-sub-space-type"
    },
    {
        "uri": "locations\/{id}\/info",
        "name": "hatchly.spaces.patch"
    },
    {
        "uri": "locations\/{space}\/settings",
        "name": "hatchly.spaces.settings.patch"
    },
    {
        "uri": "locations\/{id}\/waitinglist\/export",
        "name": "hatchly.spaces.waitinglist.export"
    },
    {
        "uri": "locations\/{id}\/approve-space\/{noEmail?}",
        "name": "hatchly.spaces.approve-space"
    },
    {
        "uri": "locations\/{id}\/follow-up-space",
        "name": "hatchly.spaces.follow-up-space"
    },
    {
        "uri": "locations\/{id}\/vat-status\/{state}",
        "name": "hatchly.spaces.vat-status"
    },
    {
        "uri": "locations\/{space}\/overnight-booking-status\/{state}",
        "name": "hatchly.spaces.overnight-booking-status"
    },
    {
        "uri": "locations\/send-email\/{space_id}",
        "name": "hatchly.spaces.sendEmailToLandlord"
    },
    {
        "uri": "locations\/associate-bookings",
        "name": "hatchly.spaces.get-associate-bookings"
    },
    {
        "uri": "locations\/associate-bookings",
        "name": "hatchly.spaces.post-associate-bookings"
    },
    {
        "uri": "locations\/booked-spaces",
        "name": "hatchly.spaces.booked-spaces"
    },
    {
        "uri": "locations\/find-owner",
        "name": "hatchly.spaces.find-owner"
    },
    {
        "uri": "locations\/move-space-to-new-owner",
        "name": "hatchly.spaces.move-space-to-new-owner"
    },
    {
        "uri": "locations\/to-remove",
        "name": "hatchly.spaces.to-remove"
    },
    {
        "uri": "locations\/{id}\/mark-to-remove",
        "name": "hatchly.spaces.mark-to-remove"
    },
    {
        "uri": "locations\/{id}\/unmark-to-remove",
        "name": "hatchly.spaces.unmark-to-remove"
    },
    {
        "uri": "locations\/draft-spaces",
        "name": "hatchly.spaces.draft"
    },
    {
        "uri": "locations\/{id}\/site-id",
        "name": "hatchly.spaces.site-id"
    },
    {
        "uri": "locations\/{id}\/regenerate-descriptions",
        "name": "hatchly.spaces.regenerate-descriptions"
    },
    {
        "uri": "locations\/{space}\/toggle-show-generated-description",
        "name": "hatchly.spaces.toggle-show-generated-descriptions"
    },
    {
        "uri": "locations\/{id}\/notes",
        "name": "hatchly.spaces.notes"
    },
    {
        "uri": "locations\/{id}\/mark-space-under-review",
        "name": "hatchly.spaces.mark-space-under-review"
    },
    {
        "uri": "locations\/{space}\/set-enforcement",
        "name": "hatchly.spaces.set-enforcement"
    },
    {
        "uri": "locations\/{space}\/yps-indexable\/{state}",
        "name": "hatchly.spaces.yps-indexable"
    },
    {
        "uri": "locations\/{space}\/permit-required\/{state}",
        "name": "hatchly.spaces.permit-required"
    },
    {
        "uri": "locations\/{space}\/allow-phone-prebookings",
        "name": "hatchly.spaces.allow-phone-prebookings"
    },
    {
        "uri": "locations\/{space}\/trustpilot-reviewable",
        "name": "hatchly.spaces.trustpilot-reviewable"
    },
    {
        "uri": "locations\/{space}\/save-post-pay-anpr",
        "name": "hatchly.api.spaces.save-post-pay-anpr"
    },
    {
        "uri": "locations\/{id}\/export-pcns",
        "name": "hatchly.spaces.export-pcns"
    },
    {
        "uri": "locations\/{id}\/title-override",
        "name": "hatchly.spaces.title-override"
    },
    {
        "uri": "locations\/{id}\/remove-listing",
        "name": "hatchly.spaces.remove-listing"
    },
    {
        "uri": "locations\/{space}\/force-vrn\/{state}",
        "name": "hatchly.spaces.force-vrn"
    },
    {
        "uri": "api\/{user}\/getLocations",
        "name": "hatchly.api.spaces.get-locations"
    },
    {
        "uri": "api\/{space}\/save-multi-entries",
        "name": "hatchly.api.spaces.save-multi-entries"
    },
    {
        "uri": "api\/{space}\/save-kiosk",
        "name": "hatchly.api.spaces.save-kiosk"
    },
    {
        "uri": "api\/{space}\/save-airport-parking",
        "name": "hatchly.api.spaces.save-airport-parking"
    },
    {
        "uri": "api\/{space}\/toggle-custom-intervals",
        "name": "hatchly.api.spaces.toggle-custom-intervals"
    },
    {
        "uri": "api\/{space}\/get-custom-intervals",
        "name": "hatchly.api.spaces.get-custom-intervals"
    },
    {
        "uri": "api\/{space}\/update-custom-intervals",
        "name": "hatchly.api.spaces.update-custom-intervals"
    },
    {
        "uri": "api\/{space}\/set-notice-required",
        "name": "hatchly.api.spaces.set-notice-required"
    },
    {
        "uri": "api\/{space}\/set-long-term-notice-required",
        "name": "hatchly.api.spaces.set-long-term-notice-required"
    },
    {
        "uri": "api\/{space}\/whitelabel-searchable",
        "name": "hatchly.api.spaces.whitelabel-searchable"
    },
    {
        "uri": "api\/{space}\/space-attribute",
        "name": "hatchly.api.spaces.space-attribute"
    },
    {
        "uri": "api\/{id}\/set-commerical-client",
        "name": "hatchly.spaces.set-commercial-client"
    },
    {
        "uri": "api\/{space}\/resend-provider-bookings",
        "name": "hatchly.api.spaces.resend-provider-bookings"
    },
    {
        "uri": "api\/{space}\/what-three-words",
        "name": "hatchly.spaces.what-three-words"
    },
    {
        "uri": "api\/{space}\/available-from",
        "name": "hatchly.api.spaces.available-from"
    },
    {
        "uri": "api\/{space}\/get-booking-totals",
        "name": "hatchly.api.spaces.booking-totals"
    },
    {
        "uri": "recommended-pricing",
        "name": "hatchly.recommended-pricing.index"
    },
    {
        "uri": "recommended-pricing\/compare",
        "name": "hatchly.recommended-pricing.compare"
    },
    {
        "uri": "recommended-pricing\/compare-location",
        "name": "hatchly.recommended-pricing.compare-location"
    },
    {
        "uri": "ivr",
        "name": "hatchly.spaces.ivr.index"
    },
    {
        "uri": "ivr\/create",
        "name": "hatchly.spaces.ivr.add"
    },
    {
        "uri": "ivr\/link",
        "name": "hatchly.spaces.ivr.link"
    },
    {
        "uri": "ivr\/unlink",
        "name": "hatchly.spaces.ivr.unlink"
    },
    {
        "uri": "spaces\/{id}\/waitinglist\/create",
        "name": "hatchly.spaces.waitinglist.create"
    },
    {
        "uri": "api\/{user}\/space-owner-bookings\/{col}\/{space?}",
        "name": "hatchly.api.bookings.spaceOwner"
    },
    {
        "uri": "api\/{user}\/driver-bookings\/{col}\/{space?}",
        "name": "hatchly.api.bookings.driver"
    },
    {
        "uri": "api\/{booking}\/update-permit",
        "name": "hatchly.api.bookings.update-permit"
    },
    {
        "uri": "bookings",
        "name": "hatchly.bookings.index"
    },
    {
        "uri": "bookings\/{id}\/evoke\/update-end-date",
        "name": "hatchly.bookings.evoke.end.date"
    },
    {
        "uri": "bookings\/{id}\/evoke\/update-price",
        "name": "hatchly.bookings.evoke.price"
    },
    {
        "uri": "bookings\/completed",
        "name": "hatchly.bookings.completed"
    },
    {
        "uri": "bookings\/completed",
        "name": "hatchly.bookings.completed"
    },
    {
        "uri": "bookings\/export-completed",
        "name": "hatchly.bookings.exportCompleted"
    },
    {
        "uri": "bookings\/days-since-last-booking",
        "name": "hatchly.bookings.daysSinceLastBooking"
    },
    {
        "uri": "bookings\/export-days-since-last-booking",
        "name": "hatchly.bookings.exportDaysSinceLastBooking"
    },
    {
        "uri": "bookings\/export",
        "name": "hatchly.bookings.export"
    },
    {
        "uri": "bookings\/show-id",
        "name": "hatchly.bookings.show-id"
    },
    {
        "uri": "bookings\/{id}\/show",
        "name": "hatchly.bookings.show"
    },
    {
        "uri": "bookings\/{id}\/debug",
        "name": "hatchly.bookings.debug"
    },
    {
        "uri": "bookings\/{id}\/notes",
        "name": "hatchly.bookings.notes.store"
    },
    {
        "uri": "bookings\/{id}\/notes",
        "name": "hatchly.bookings.notes.index"
    },
    {
        "uri": "bookings\/{id}\/confirm",
        "name": "hatchly.bookings.confirm"
    },
    {
        "uri": "bookings\/{id}\/show",
        "name": "hatchly.bookings.show"
    },
    {
        "uri": "bookings\/{id}\/edit",
        "name": "hatchly.bookings.edit"
    },
    {
        "uri": "bookings\/{id}\/edit",
        "name": "hatchly.bookings.update"
    },
    {
        "uri": "bookings\/{id}\/patch",
        "name": "hatchly.bookings.patch"
    },
    {
        "uri": "bookings\/{booking}\/assign-agent",
        "name": "hatchly.bookings.assign-agent"
    },
    {
        "uri": "bookings\/{id}\/cancel",
        "name": "hatchly.bookings.cancel"
    },
    {
        "uri": "bookings\/{id}\/un-cancel",
        "name": "hatchly.bookings.un-cancel"
    },
    {
        "uri": "bookings\/{id}\/mark_as_cancelled",
        "name": "hatchly.bookings.markAsCancelled"
    },
    {
        "uri": "bookings\/{id}\/confirmation\/landlord",
        "name": "hatchly.bookings.confirmation.landlord"
    },
    {
        "uri": "bookings\/{id}\/confirmation\/tenant",
        "name": "hatchly.bookings.confirmation.tenant"
    },
    {
        "uri": "bookings\/{id}\/resend-confirmation\/tenant",
        "name": "hatchly.bookings.resend-confirmation.tenant"
    },
    {
        "uri": "bookings\/{id}\/resend-confirmation\/landlord",
        "name": "hatchly.bookings.resend-confirmation.landlord"
    },
    {
        "uri": "bookings\/user\/{id}",
        "name": "hatchly.bookings.user"
    },
    {
        "uri": "bookings\/first-booking",
        "name": "hatchly.bookings.firstBooking"
    },
    {
        "uri": "bookings\/disabled-space-bookings",
        "name": "hatchly.bookings.disabledSpaceBookings"
    },
    {
        "uri": "bookings\/{type}\/{booking_id}\/log\/{user_id?}",
        "name": "hatchly.bookings.log"
    },
    {
        "uri": "bookings\/{bookingId}\/schedule-action",
        "name": "hatchly.bookings.store-schedule-action"
    },
    {
        "uri": "bookings\/{bookingId}\/schedule-action\/{id}",
        "name": "hatchly.bookings.update-scheduled-action"
    },
    {
        "uri": "bookings\/{bookingId}\/schedule-action\/{id}",
        "name": "hatchly.bookings.delete-scheduled-action"
    },
    {
        "uri": "bookings\/geo-search",
        "name": "hatchly.bookings.geo-search"
    },
    {
        "uri": "bookings\/{id}\/send-vat-receipt\/{payment_tracker_id?}",
        "name": "hatchly.bookings.vat-receipt"
    },
    {
        "uri": "bookings\/{booking}\/download-st-vat-receipt",
        "name": "hatchly.bookings.download-st-vat-receipt"
    },
    {
        "uri": "bookings\/{id}\/send-vat-receipt",
        "name": "hatchly.bookings.send-vat-receipt"
    },
    {
        "uri": "bookings\/notes\/attach",
        "name": "hatchly.bookings.notes.attach"
    },
    {
        "uri": "bookings\/notes\/attachments\/{attachment}\/delete",
        "name": "hatchly.bookings.notes.attachments.delete"
    },
    {
        "uri": "bookings\/{bookingId}\/add-actioned-tag",
        "name": "hatchly.bookings.add-actioned-tag"
    },
    {
        "uri": "bookings\/{id}\/update-activity",
        "name": "hatchly.bookings.update-activity"
    },
    {
        "uri": "bookings\/{id}\/vrm-history",
        "name": "hatchly.bookings.vrm-history"
    },
    {
        "uri": "bookings\/{id}\/get-pcn",
        "name": "hatchly.bookings.pcn.get"
    },
    {
        "uri": "bookings\/{id}\/pcn",
        "name": "hatchly.bookings.pcn.store"
    },
    {
        "uri": "bookings\/pcn",
        "name": "hatchly.bookings.pcn"
    },
    {
        "uri": "bookings\/{id}\/change-price",
        "name": "hatchly.bookings.change-price"
    },
    {
        "uri": "bookings\/{booking}\/recalculate-recurring-arrangement-fee",
        "name": "hatchly.bookings.recalculate-recurring-arrangement-fee"
    },
    {
        "uri": "bookings\/{id}\/refund-product",
        "name": "hatchly.bookings.refund-product"
    },
    {
        "uri": "bookings\/{id}\/override-refund-product",
        "name": "hatchly.bookings.override-refund-product"
    },
    {
        "uri": "bookings\/get-retainer-types",
        "name": "hatchly.bookings.get-retainer-types"
    },
    {
        "uri": "bookings\/qr\/{bookingId}\/upload",
        "name": "hatchly.bookings.upload-qr"
    },
    {
        "uri": "bookings\/qr\/{attachableId}\/remove",
        "name": "hatchly.bookings.remove-qr-code"
    },
    {
        "uri": "bookings\/bulk-cancel\/{spaceId}",
        "name": "hatchly.bookings.show-bulk-cancellation"
    },
    {
        "uri": "bookings\/pause\/configs",
        "name": "hatchly.bookings.pause.configs"
    },
    {
        "uri": "bookings\/pause\/configs",
        "name": "hatchly.bookings.pause.configs"
    },
    {
        "uri": "bookings\/mpp",
        "name": "hatchly.bookings.mpp.index"
    },
    {
        "uri": "settings",
        "name": "hatchly.settings.index"
    },
    {
        "uri": "settings",
        "name": "hatchly.settings.index"
    },
    {
        "uri": "settings\/languages",
        "name": "hatchly.settings.languages"
    },
    {
        "uri": "settings\/languages\/add",
        "name": "hatchly.settings.languages.add"
    },
    {
        "uri": "settings\/languages\/add",
        "name": "hatchly.settings.languages.store"
    },
    {
        "uri": "settings\/languages\/{languageKey}\/edit",
        "name": "hatchly.settings.languages.edit"
    },
    {
        "uri": "settings\/languages\/{languageKey}\/edit",
        "name": "hatchly.settings.languages.update"
    },
    {
        "uri": "settings\/{pageKey}",
        "name": "hatchly.settings.page"
    },
    {
        "uri": "settings\/{pageKey}",
        "name": "hatchly.settings.page"
    },
    {
        "uri": "setup-two-factor",
        "name": "auth.setup-two-factor"
    },
    {
        "uri": "setup-two-factor",
        "name": "auth.setup-two-factor"
    },
    {
        "uri": "users",
        "name": "hatchly.users.index"
    },
    {
        "uri": "users\/deleted",
        "name": "hatchly.users.deleted"
    },
    {
        "uri": "users\/{userId}\/restore",
        "name": "hatchly.users.restore"
    },
    {
        "uri": "users\/create",
        "name": "hatchly.users.create"
    },
    {
        "uri": "users\/create",
        "name": "hatchly.users.store"
    },
    {
        "uri": "users\/upload",
        "name": "hatchly.users.upload"
    },
    {
        "uri": "users\/upload",
        "name": "hatchly.users.store-upload"
    },
    {
        "uri": "users\/{userId}\/edit",
        "name": "hatchly.users.edit"
    },
    {
        "uri": "users\/{userId}\/edit",
        "name": "hatchly.users.update"
    },
    {
        "uri": "users\/{userId}\/edit\/permissions",
        "name": "hatchly.users.edit-permissions"
    },
    {
        "uri": "users\/{userId}\/edit\/permissions",
        "name": "hatchly.users.edit-permissions"
    },
    {
        "uri": "users\/{userId}\/edit\/tax-information",
        "name": "hatchly.users.tax-information"
    },
    {
        "uri": "users\/{userId}\/impersonate",
        "name": "hatchly.users.impersonate"
    },
    {
        "uri": "users\/{userId}\/delete",
        "name": "hatchly.users.delete"
    },
    {
        "uri": "groups",
        "name": "hatchly.groups.index"
    },
    {
        "uri": "groups\/create",
        "name": "hatchly.groups.create"
    },
    {
        "uri": "groups\/create",
        "name": "hatchly.groups.store"
    },
    {
        "uri": "groups\/{groupId}\/edit",
        "name": "hatchly.groups.edit"
    },
    {
        "uri": "groups\/{groupId}\/edit",
        "name": "hatchly.groups.update"
    },
    {
        "uri": "groups\/{groupId}\/edit\/permissions",
        "name": "hatchly.groups.edit-permissions"
    },
    {
        "uri": "groups\/{groupId}\/edit\/permissions",
        "name": "hatchly.groups.edit-permissions"
    },
    {
        "uri": "groups\/{groupId}\/edit\/users",
        "name": "hatchly.groups.edit-users"
    },
    {
        "uri": "groups\/{groupId}\/edit\/users",
        "name": "hatchly.groups.edit-users"
    },
    {
        "uri": "groups\/{groupId}\/delete",
        "name": "hatchly.groups.delete"
    },
    {
        "uri": "closed-accounts",
        "name": "hatchly.closed-accounts.index"
    },
    {
        "uri": "closed-accounts\/authorise",
        "name": "hatchly.closed-accounts.authorise"
    },
    {
        "uri": "finance",
        "name": "hatchly.finance.index"
    },
    {
        "uri": "finance\/dashboard\/chart",
        "name": "hatchly.finance.dashboard.chart"
    },
    {
        "uri": "finance\/spaceowners\/payment-change",
        "name": "hatchly.finance.spaceowners.payment-change"
    },
    {
        "uri": "finance\/spaceowners\/payment-change\/{change}",
        "name": "hatchly.finance.spaceowners.payment-change.delete"
    },
    {
        "uri": "finance\/spaceowners\/payment-change",
        "name": "hatchly.finance.spaceowners.payment-change.deleteBulk"
    },
    {
        "uri": "finance\/spaceowners\/payment-change\/access",
        "name": "hatchly.finance.spaceowners.payment-change.access"
    },
    {
        "uri": "finance\/spaceowners\/custom-ledger",
        "name": "hatchly.finance.space-owners.custom-ledger.index"
    },
    {
        "uri": "finance\/spaceowners\/custom-ledger\/add",
        "name": "hatchly.finance.space-owners.custom-ledger.add"
    },
    {
        "uri": "finance\/spaceowners\/custom-ledger\/{ledgerItem}",
        "name": "hatchly.finance.space-owners.custom-ledger.edit"
    },
    {
        "uri": "finance\/spaceowners\/custom-ledger\/{ledgerItem}",
        "name": "hatchly.finance.space-owners.custom-ledger.destroy"
    },
    {
        "uri": "finance\/spaceowners\/remittance-settings",
        "name": "hatchly.finance.space-owners.remittance-settings.index"
    },
    {
        "uri": "finance\/spaceowners\/private\/payments",
        "name": "hatchly.finance.space-owners.private.payments.index"
    },
    {
        "uri": "finance\/spaceowners\/private\/payments\/replacement-index",
        "name": "hatchly.finance.space-owners.private.payments.replacement-index"
    },
    {
        "uri": "finance\/incoming\/short-term-payments",
        "name": "hatchly.finance.in.short"
    },
    {
        "uri": "finance\/incoming\/subscriptions",
        "name": "hatchly.finance.in.subscriptions.active"
    },
    {
        "uri": "finance\/incoming\/subscriptions\/due-yesterday",
        "name": "hatchly.finance.in.subscriptions.due-today"
    },
    {
        "uri": "finance\/incoming\/subscriptions\/missed-payments",
        "name": "hatchly.finance.in.subscriptions.missed-payments"
    },
    {
        "uri": "finance\/incoming\/subscriptions\/ended",
        "name": "hatchly.finance.in.subscriptions.ended"
    },
    {
        "uri": "finance\/incoming\/subscriptions\/active-without-payment-row",
        "name": "hatchly.finance.in.subscriptions.active-without-payment-row"
    },
    {
        "uri": "finance\/incoming\/subscriptions\/{booking_id}\/history",
        "name": "hatchly.finance.in.subscriptions.history"
    },
    {
        "uri": "finance\/incoming\/subscriptions\/{id}\/edit",
        "name": "hatchly.finance.edit"
    },
    {
        "uri": "finance\/incoming\/subscriptions\/import",
        "name": "hatchly.finance.in.subscriptions.import"
    },
    {
        "uri": "finance\/incoming\/subscriptions\/{booking_id}\/store",
        "name": "hatchly.finance.in.subscriptions.store"
    },
    {
        "uri": "finance\/incoming\/subscriptions\/{id}\/update",
        "name": "hatchly.finance.in.subscriptions.update"
    },
    {
        "uri": "finance\/incoming\/subscriptions\/{id}\/mark-as-paid",
        "name": "hatchly.finance.in.subscriptions.mark-as-paid"
    },
    {
        "uri": "finance\/incoming\/subscriptions\/{id}\/admin-notes",
        "name": "hatchly.finance.in.subscriptions.admin-notes"
    },
    {
        "uri": "finance\/incoming\/subscriptions\/{id}\/change-billing-method",
        "name": "hatchly.finance.in.subscription.change-billing-method"
    },
    {
        "uri": "finance\/incoming\/subscriptions\/{id}\/refund",
        "name": "hatchly.finance.in.subscriptions.refund"
    },
    {
        "uri": "finance\/incoming\/subscriptions\/delete-payment\/{payment_id}",
        "name": "hatchly.finance.in.subscriptions.delete-payment"
    },
    {
        "uri": "finance\/incoming\/subscriptions\/send-missed-payment-sms\/{booking_id}",
        "name": "hatchly.finance.in.subscriptions.send-missed-payment-sms"
    },
    {
        "uri": "finance\/incoming\/subscriptions\/send-missed-payment-email\/{booking_id}",
        "name": "hatchly.finance.in.subscriptions.send-missed-payment-email"
    },
    {
        "uri": "finance\/incoming\/subscriptions\/{booking_id}\/store-subscription",
        "name": "hatchly.finance.in.subscriptions.store-subscription"
    },
    {
        "uri": "finance\/outgoing\/short-term-payments",
        "name": "hatchly.finance.out.short"
    },
    {
        "uri": "finance\/outgoing\/short-term-payments\/previous\/{date?}",
        "name": "hatchly.finance.out.short.previous"
    },
    {
        "uri": "finance\/outgoing\/short-term-payments\/{landlordId}\/pending-bookings",
        "name": "hatchly.finance.out.short.pending-bookings"
    },
    {
        "uri": "finance\/outgoing\/short-term-payments\/{landlordId}\/previous-bookings\/{month}",
        "name": "hatchly.finance.out.short.previous-bookings"
    },
    {
        "uri": "finance\/outgoing\/short-term-payments\/{landlordId}\/mark-as-paid",
        "name": "hatchly.finance.out.short.mark-as-paid"
    },
    {
        "uri": "finance\/outgoing\/short-term-payments\/export",
        "name": "hatchly.finance.out.short.export"
    },
    {
        "uri": "finance\/outgoing\/short-term-payments\/bulk-mark-as-paid",
        "name": "hatchly.finance.out.short.bulk-mark-as-paid"
    },
    {
        "uri": "finance\/outgoing\/short-term-payments\/import",
        "name": "hatchly.finance.out.short.import"
    },
    {
        "uri": "finance\/outgoing\/short-term-payments\/hide-background-job\/{job}",
        "name": "hatchly.finance.out.short.hide-background-job"
    },
    {
        "uri": "finance\/outgoing\/short-term-payments\/export-failed-import-job\/{job}",
        "name": "hatchly.finance.out.short.export-failed-import"
    },
    {
        "uri": "finance\/outgoing\/short-term-payments\/export-failed-automatic-mark-as-paid\/{job}",
        "name": "hatchly.finance.out.short.export-failed-automatic-mark-as-paid"
    },
    {
        "uri": "finance\/outgoing\/short-term-payments\/export-failed-import\/{filename}",
        "name": "hatchly.finance.out.export-failed-import"
    },
    {
        "uri": "finance\/outgoing\/subscriptions",
        "name": "hatchly.finance.out.subscriptions"
    },
    {
        "uri": "finance\/outgoing\/subscriptions\/{booking_id}\/history",
        "name": "hatchly.finance.out.subscriptions.history"
    },
    {
        "uri": "finance\/outgoing\/subscriptions\/{id}\/mark-as-paid",
        "name": "hatchly.finance.out.subscriptions.mark-as-paid"
    },
    {
        "uri": "finance\/outgoing\/subscriptions\/bulk-mark-as-paid",
        "name": "hatchly.finance.out.subscriptions.bulk-mark-as-paid"
    },
    {
        "uri": "finance\/outgoing\/subscriptions\/import",
        "name": "hatchly.finance.out.subscriptions.import"
    },
    {
        "uri": "finance\/outgoing\/subscriptions\/export",
        "name": "hatchly.finance.out.subscriptions.export"
    },
    {
        "uri": "finance\/outgoing\/subscriptions\/generate",
        "name": "hatchly.finance.out.subscriptions.generate"
    },
    {
        "uri": "finance\/pricing-history",
        "name": "hatchly.finance.pricing-history.index"
    },
    {
        "uri": "finance\/pricing-history\/data",
        "name": "hatchly.finance.pricing-history.data"
    },
    {
        "uri": "finance\/pricing-history\/toggle",
        "name": "hatchly.finance.pricing-history.toggle"
    },
    {
        "uri": "finance\/pricing-history\/spaces",
        "name": "hatchly.finance.pricing-history.spaces"
    },
    {
        "uri": "finance\/pricing-history\/initial-load",
        "name": "hatchly.finance.pricing-history.initial-load"
    },
    {
        "uri": "finance\/mrdp",
        "name": "hatchly.finance.mrdp.index"
    },
    {
        "uri": "finance\/mrdp",
        "name": "hatchly.finance.mrdp.store"
    },
    {
        "uri": "finance\/mrdp\/access",
        "name": "hatchly.finance.mrdp.access"
    },
    {
        "uri": "auto-pay",
        "name": "hatchly.auto-pay::index"
    },
    {
        "uri": "auto-pay\/locations",
        "name": "hatchly.auto-pay::locations"
    },
    {
        "uri": "auto-pay\/vehicles",
        "name": "hatchly.auto-pay::vehicles"
    },
    {
        "uri": "auto-pay\/whitelist",
        "name": "hatchly.auto-pay::whitelist"
    },
    {
        "uri": "auto-pay\/whitelist\/create",
        "name": "hatchly.auto-pay::whitelist.create"
    },
    {
        "uri": "auto-pay\/whitelist\/{item}\/edit",
        "name": "hatchly.auto-pay::whitelist.edit"
    },
    {
        "uri": "auto-pay\/whitelist\/store",
        "name": "hatchly.auto-pay::whitelist.store"
    },
    {
        "uri": "auto-pay\/whitelist\/{item}\/update",
        "name": "hatchly.auto-pay::whitelist.update"
    },
    {
        "uri": "auto-pay\/whitelist\/{item}\/delete",
        "name": "hatchly.auto-pay::whitelist.delete"
    },
    {
        "uri": "auto-pay\/whitelist-url\/url-qr-code-image",
        "name": "hatchly.auto-pay::whitelist-url.qr-code-image"
    },
    {
        "uri": "auto-pay\/whitelist-url\/url-qr-code-pdf",
        "name": "hatchly.auto-pay::whitelist-url.qr-code-pdf"
    },
    {
        "uri": "auto-pay\/outstanding-payments",
        "name": "hatchly.auto-pay::outstanding-payments.index"
    },
    {
        "uri": "whitelabel",
        "name": "hatchly.whitelabel.index"
    },
    {
        "uri": "whitelabel\/{instance}",
        "name": "hatchly.whitelabel.edit"
    },
    {
        "uri": "whitelabel\/{instance}",
        "name": "hatchly.whitelabel.edit"
    },
    {
        "uri": "whitelabel\/{instance}\/bookings",
        "name": "hatchly.whitelabel.bookings"
    },
    {
        "uri": "whitelabel\/{instance}\/locations",
        "name": "hatchly.whitelabel.locations"
    },
    {
        "uri": "whitelabel\/{instance}\/upload-favicon",
        "name": "hatchly.whitelabel.upload-favicon"
    },
    {
        "uri": "whitelabel\/{instance}\/total-revenue",
        "name": "hatchly.whitelabel.total-revenue"
    },
    {
        "uri": "fleet",
        "name": "hatchly.corporate-account::index"
    },
    {
        "uri": "fleet\/accounts",
        "name": "hatchly.corporate-account::accounts.index"
    },
    {
        "uri": "fleet\/accounts\/create",
        "name": "hatchly.corporate-account::accounts.create"
    },
    {
        "uri": "fleet\/accounts",
        "name": "hatchly.corporate-account::accounts.store"
    },
    {
        "uri": "fleet\/accounts\/{account}",
        "name": "hatchly.corporate-account::accounts.view"
    },
    {
        "uri": "fleet\/accounts\/{account}\/edit",
        "name": "hatchly.corporate-account::accounts.edit"
    },
    {
        "uri": "fleet\/accounts\/{account}",
        "name": "hatchly.corporate-account::accounts.update"
    },
    {
        "uri": "fleet\/accounts\/{account}\/pause",
        "name": "hatchly.corporate-account::accounts.pause"
    },
    {
        "uri": "fleet\/accounts\/{account}\/total-spend",
        "name": "hatchly.corporate-account::accounts.total-spend"
    },
    {
        "uri": "fleet\/accounts\/users",
        "name": "hatchly.corporate-account::accounts.users.link"
    },
    {
        "uri": "fleet\/accounts\/{account}\/users",
        "name": "hatchly.corporate-account::accounts.users.index"
    },
    {
        "uri": "fleet\/accounts\/{account}\/users",
        "name": "hatchly.corporate-account::accounts.users.store"
    },
    {
        "uri": "fleet\/accounts\/{account}\/users\/create",
        "name": "hatchly.corporate-account::accounts.users.create"
    },
    {
        "uri": "fleet\/accounts\/{account}\/users\/bulk-create",
        "name": "hatchly.corporate-account::accounts.users.store.bulk"
    },
    {
        "uri": "fleet\/accounts\/{account}\/users\/{user}",
        "name": "hatchly.corporate-account::accounts.users.view"
    },
    {
        "uri": "fleet\/accounts\/{account}\/users\/{user}\/admin",
        "name": "hatchly.corporate-account::accounts.users.admin"
    },
    {
        "uri": "fleet\/accounts\/{account}\/users\/{user}",
        "name": "hatchly.corporate-account::accounts.users.destroy"
    },
    {
        "uri": "fleet\/accounts\/{account}\/bookings",
        "name": "hatchly.corporate-account::accounts.bookings.index"
    },
    {
        "uri": "fleet\/users",
        "name": "hatchly.corporate-account::users.index"
    },
    {
        "uri": "fleet\/bookings",
        "name": "hatchly.corporate-account::bookings.index"
    },
    {
        "uri": "fleet\/settings",
        "name": "hatchly.corporate-account::settings.index"
    },
    {
        "uri": "fleet\/bulk-users-create",
        "name": "hatchly.corporate-account::accounts.users.create.bulk"
    },
    {
        "uri": "fleet\/finance",
        "name": "hatchly.corporate-account::finance.index"
    },
    {
        "uri": "fleet\/finance\/reports",
        "name": "hatchly.corporate-account::finance.reports.store"
    },
    {
        "uri": "fleet\/finance\/reports",
        "name": "hatchly.corporate-account::finance.reports.index"
    },
    {
        "uri": "fleet\/finance\/reports\/{report}",
        "name": "hatchly.corporate-account::finance.reports.download"
    },
    {
        "uri": "providers",
        "name": "hatchly.providers::index"
    },
    {
        "uri": "providers\/file-upload-provider",
        "name": "hatchly.providers::file-upload-provider"
    },
    {
        "uri": "providers\/file-upload-provider-add",
        "name": "hatchly.providers::file-upload-provider-add"
    },
    {
        "uri": "providers\/file-upload-provider-delete\/{provider}",
        "name": "hatchly.providers::file-upload-provider-delete"
    },
    {
        "uri": "providers\/file-upload-provider-add",
        "name": "hatchly.providers::file-upload-provider-add"
    },
    {
        "uri": "providers\/new-provider-user",
        "name": "hatchly.providers::new-provider-user"
    },
    {
        "uri": "providers\/new-provider-user",
        "name": "hatchly.providers::new-user-provider"
    },
    {
        "uri": "providers\/check-email",
        "name": "hatchly.providers::check-email"
    },
    {
        "uri": "providers\/{providerId}\/edit",
        "name": "hatchly.providers::edit"
    },
    {
        "uri": "providers\/{providerId}\/edit",
        "name": "hatchly.providers::edit"
    },
    {
        "uri": "providers\/{user_id}\/manage-locations",
        "name": "hatchly.providers::manage-locations"
    },
    {
        "uri": "providers\/{user_id}\/manage-locations",
        "name": "hatchly.providers::manage-locations"
    },
    {
        "uri": "providers\/terminal\/{booking}",
        "name": "hatchly.providers::terminal.booking"
    },
    {
        "uri": "providers\/terminal\/{booking}\/new",
        "name": "hatchly.providers::terminal.new"
    },
    {
        "uri": "providers\/opss-resend",
        "name": "hatchly.providers::opss-resend.index"
    },
    {
        "uri": "providers\/opss-resend",
        "name": "hatchly.providers::opss-resend.post"
    },
    {
        "uri": "providers\/opss-resend\/template",
        "name": "hatchly.providers::opss-resend.template"
    },
    {
        "uri": "reviews",
        "name": "hatchly.reviews.index"
    },
    {
        "uri": "reviews\/approved",
        "name": "hatchly.reviews.approved"
    },
    {
        "uri": "reviews\/deleted",
        "name": "hatchly.reviews.deleted"
    },
    {
        "uri": "reviews\/all",
        "name": "hatchly.reviews.all"
    },
    {
        "uri": "reviews\/store",
        "name": "hatchly.reviews.store"
    },
    {
        "uri": "reviews\/{id}\/approve",
        "name": "hatchly.reviews.approve"
    },
    {
        "uri": "reviews\/{id}\/edit",
        "name": "hatchly.reviews.edit"
    },
    {
        "uri": "reviews\/{id}\/edit",
        "name": "hatchly.reviews.edit"
    },
    {
        "uri": "reviews\/{id}\/delete",
        "name": "hatchly.reviews.delete"
    },
    {
        "uri": "reviews\/{id}\/restore",
        "name": "hatchly.reviews.restore"
    },
    {
        "uri": "reviews\/space\/{space_id}",
        "name": "hatchly.reviews.space"
    },
    {
        "uri": "reviews\/bulk-action",
        "name": "hatchly.reviews.bulk-action"
    },
    {
        "uri": "reviews\/add",
        "name": "hatchly.reviews.add"
    },
    {
        "uri": "reviews\/add-for-customer",
        "name": "hatchly.reviews.addForCustomer"
    },
    {
        "uri": "locationnotifications",
        "name": "hatchly.locationnotifications::index"
    },
    {
        "uri": "locationnotifications\/{id}",
        "name": "hatchly.locationnotifications::delete"
    },
    {
        "uri": "vouchers",
        "name": "hatchly.vouchers::index"
    },
    {
        "uri": "vouchers\/inactive",
        "name": "hatchly.vouchers::inactive"
    },
    {
        "uri": "vouchers\/archived",
        "name": "hatchly.vouchers::archived"
    },
    {
        "uri": "vouchers\/create",
        "name": "hatchly.vouchers::create"
    },
    {
        "uri": "vouchers\/store",
        "name": "hatchly.vouchers::store"
    },
    {
        "uri": "vouchers\/{voucher_id}\/edit",
        "name": "hatchly.vouchers::edit"
    },
    {
        "uri": "vouchers\/{voucher_id}\/update",
        "name": "hatchly.vouchers::update"
    },
    {
        "uri": "vouchers\/delete",
        "name": "hatchly.vouchers::deleteBatch"
    },
    {
        "uri": "vouchers\/delete\/{voucher_id}",
        "name": "hatchly.vouchers::delete"
    },
    {
        "uri": "vouchers\/generate-batch",
        "name": "hatchly.vouchers::generate-batch"
    },
    {
        "uri": "vouchers\/generate-batch",
        "name": "hatchly.vouchers::generate-batch"
    },
    {
        "uri": "vouchers\/bulk-archive",
        "name": "hatchly.vouchers::bulk-archive-show"
    },
    {
        "uri": "vouchers\/bulk-archive",
        "name": "hatchly.vouchers::bulk-archive"
    },
    {
        "uri": "vouchers\/bulk-archive-confirm",
        "name": "hatchly.vouchers::bulk-archive-confirm"
    },
    {
        "uri": "vouchers\/api\/{user}\/driver-vouchers",
        "name": "hatchly.api.vouchers.driver-vouchers"
    },
    {
        "uri": "vouchers\/api\/{user}\/delete-voucher\/{voucher}",
        "name": "hatchly.api.vouchers.delete-voucher"
    },
    {
        "uri": "vouchers\/api\/{user}\/sort-vouchers",
        "name": "hatchly.api.vouchers.sort-vouchers"
    },
    {
        "uri": "vouchers\/api\/{user}\/save-voucher",
        "name": "hatchly.api.vouchers.save-voucher"
    },
    {
        "uri": "users\/api\/{user}\/user-emails",
        "name": "hatchly.users.email.index"
    },
    {
        "uri": "users\/api\/{user}\/user-save",
        "name": "hatchly.api.users.update"
    },
    {
        "uri": "users\/api\/{user}\/communication-preferences",
        "name": "hatchly.api.users.communication.update"
    },
    {
        "uri": "users\/api\/{user}\/user-save-roles",
        "name": "hatchly.api.users.roles.update"
    },
    {
        "uri": "users\/api\/{user}\/verify-email",
        "name": "hatchly.users.verify-email"
    },
    {
        "uri": "users\/api\/{user}\/verify-phone-number",
        "name": "hatchly.users.verify-phone-number"
    },
    {
        "uri": "users\/api\/{user}\/password-reset-link",
        "name": "hatchly.users.password-reset-link"
    },
    {
        "uri": "users\/api\/{user}\/password-reset",
        "name": "hatchly.users.password-reset"
    },
    {
        "uri": "users\/api\/{userId}\/vehicles",
        "name": "hatchly.api.users.vehicles"
    },
    {
        "uri": "users\/api\/{user}\/fleet-notification-preferences",
        "name": "hatchly.api.users.fleet-notification-preferences.update"
    },
    {
        "uri": "users\/{user_id}\/unsubscribe",
        "name": "hatchly.users.unsubscribe"
    },
    {
        "uri": "users\/{id}\/close-account",
        "name": "hatchly.users.close-account"
    },
    {
        "uri": "users\/{id}\/close-account\/active-bookings",
        "name": "hatchly.users.close-account.active-bookings"
    },
    {
        "uri": "users\/get-agents",
        "name": "hatchly.users.get-agents"
    },
    {
        "uri": "commercial\/premier-inn",
        "name": "hatchly.commercial.premier-inn.index"
    },
    {
        "uri": "commercial\/premier-inn\/emails\/create",
        "name": "hatchly.commercial.premier-inn.emails.create"
    },
    {
        "uri": "commercial\/premier-inn\/emails",
        "name": "hatchly.commercial.premier-inn.emails.store"
    },
    {
        "uri": "commercial\/premier-inn\/emails",
        "name": "hatchly.commercial.premier-inn.emails.delete"
    },
    {
        "uri": "commercial\/premier-inn\/locations",
        "name": "hatchly.commercial.premier-inn.locations.index"
    },
    {
        "uri": "commercial\/premier-inn\/locations\/create",
        "name": "hatchly.commercial.premier-inn.locations.create"
    },
    {
        "uri": "commercial\/premier-inn\/locations",
        "name": "hatchly.commercial.premier-inn.locations.store"
    },
    {
        "uri": "commercial\/premier-inn\/locations",
        "name": "hatchly.commercial.premier-inn.locations.delete"
    },
    {
        "uri": "pages",
        "name": "hatchly.pages.index"
    },
    {
        "uri": "pages\/feed\/{pageId?}",
        "name": "hatchly.pages.feed"
    },
    {
        "uri": "pages\/create\/{pageId?}",
        "name": "hatchly.pages.create"
    },
    {
        "uri": "pages\/create\/{pageId?}",
        "name": "hatchly.pages.store"
    },
    {
        "uri": "pages\/{pageId}\/edit\/{lang}",
        "name": "hatchly.pages.edit"
    },
    {
        "uri": "pages\/{pageId}\/edit\/{lang}",
        "name": "hatchly.pages.update"
    },
    {
        "uri": "pages\/{pageId}\/history\/{lang}\/{filter?}",
        "name": "hatchly.pages.history"
    },
    {
        "uri": "pages\/{pageId}\/history\/{lang}",
        "name": "hatchly.pages.restore"
    },
    {
        "uri": "pages\/{pageId}\/remove",
        "name": "hatchly.pages.remove"
    },
    {
        "uri": "pages\/{pageId}\/duplicate",
        "name": "hatchly.pages.duplicate"
    },
    {
        "uri": "pages\/_ajax\/order-pages",
        "name": "hatchly.pages.ajax.order-pages"
    },
    {
        "uri": "pages\/_ajax\/repeatable-section\/{pageId}\/{template}\/{sectionKey}\/{collectionKeys?}",
        "name": "hatchly.pages.ajax.repeatable-section"
    },
    {
        "uri": "pages\/_ajax\/repeatable-section\/remove",
        "name": "hatchly.pages.ajax.repeatable-section.remove"
    },
    {
        "uri": "pages\/_ajax\/selectable-section\/{pageId}\/{template}\/{sectionKey}\/{subSectionKey}\/{collectionKey?}",
        "name": "hatchly.pages.ajax.selectable-section"
    },
    {
        "uri": "pages\/_ajax\/selectable-section\/remove",
        "name": "hatchly.pages.ajax.selectable-section.remove"
    },
    {
        "uri": "pages\/_ajax\/slug\/validate",
        "name": "hatchly.pages.ajax.slug.validate"
    },
    {
        "uri": "categories",
        "name": "hatchly.categories.index"
    },
    {
        "uri": "categories\/create\/{categoryId?}",
        "name": "hatchly.categories.create"
    },
    {
        "uri": "categories\/create\/{categoryId?}",
        "name": "hatchly.categories.store"
    },
    {
        "uri": "categories\/{categoryId}\/edit",
        "name": "hatchly.categories.edit"
    },
    {
        "uri": "categories\/{categoryId}\/edit",
        "name": "hatchly.categories.update"
    },
    {
        "uri": "categories\/{categoryId}\/remove",
        "name": "hatchly.categories.remove"
    },
    {
        "uri": "developer\/pages",
        "name": "hatchly.developer.pages.index"
    },
    {
        "uri": "developer\/pages\/export-contents",
        "name": "hatchly.developer.pages.export-contents"
    },
    {
        "uri": "files\/_ajax\/get_directory",
        "name": "hatchly.files.get_directory"
    },
    {
        "uri": "files\/_ajax\/get_file\/{fileId}",
        "name": "hatchly.files.get_file"
    },
    {
        "uri": "files\/_ajax\/get_meta_form\/{fileId}",
        "name": "hatchly.files.get_meta_form"
    },
    {
        "uri": "files\/_ajax\/update_meta\/{fileId}",
        "name": "hatchly.files.update_meta"
    },
    {
        "uri": "files\/_ajax\/delete_file\/{fileId}",
        "name": "hatchly.files.deleteFile"
    },
    {
        "uri": "files\/_ajax\/edit_folder\/{folderId}\/{currentDirectory?}",
        "name": "hatchly.files.edit_folder"
    },
    {
        "uri": "files\/_ajax\/edit_folder\/{folderId}\/{currentDirectory?}",
        "name": "hatchly.files.edit_folder"
    },
    {
        "uri": "files\/_ajax\/edit_folder\/{folderId}",
        "name": "hatchly.files.delete_folder"
    },
    {
        "uri": "files",
        "name": "hatchly.files.index"
    },
    {
        "uri": "files\/file-browser",
        "name": "hatchly.files.file-browser"
    },
    {
        "uri": "files",
        "name": "hatchly.files.upload"
    },
    {
        "uri": "file\/{fileName}",
        "name": "hatchly.files.serve"
    },
    {
        "uri": "redirects",
        "name": "hatchly.redirects.index"
    },
    {
        "uri": "redirects\/create",
        "name": "hatchly.redirects.create"
    },
    {
        "uri": "redirects\/create",
        "name": "hatchly.redirects.store"
    },
    {
        "uri": "redirects\/{snippetKey}\/edit",
        "name": "hatchly.redirects.edit"
    },
    {
        "uri": "redirects\/{snippetKey}\/edit",
        "name": "hatchly.redirects.update"
    },
    {
        "uri": "redirects\/{snippetKey}\/remove",
        "name": "hatchly.redirects.remove"
    },
    {
        "uri": "navigation",
        "name": "hatchly.navigation.index"
    },
    {
        "uri": "navigation\/create",
        "name": "hatchly.navigation.create"
    },
    {
        "uri": "navigation\/create",
        "name": "hatchly.navigation.store"
    },
    {
        "uri": "navigation\/{navigationGroup}\/edit",
        "name": "hatchly.navigation.edit"
    },
    {
        "uri": "navigation\/{navigationGroup}\/edit",
        "name": "hatchly.navigation.update"
    },
    {
        "uri": "navigation\/{navigationGroup}",
        "name": "hatchly.navigation.remove"
    },
    {
        "uri": "navigation\/{navigationGroup}\/create\/{parentId?}",
        "name": "hatchly.navigation.item.create"
    },
    {
        "uri": "navigation\/{navigationGroup}\/create\/{parentId?}",
        "name": "hatchly.navigation.item.store"
    },
    {
        "uri": "navigation\/{navigationGroup}\/{itemId}\/edit\/{lang}",
        "name": "hatchly.navigation.item.edit"
    },
    {
        "uri": "navigation\/{navigationGroup}\/{itemId}\/edit\/{lang}",
        "name": "hatchly.navigation.item.update"
    },
    {
        "uri": "navigation\/{navigationGroup}\/{navigationItem}\/remove",
        "name": "hatchly.navigation.item.remove"
    },
    {
        "uri": "navigation\/_ajax\/order-items",
        "name": "hatchly.navigation.ajax.order-items"
    },
    {
        "uri": "vehicles\/blacklist",
        "name": "hatchly.vehicles.blacklist"
    },
    {
        "uri": "vehicles\/blacklist\/add",
        "name": "hatchly.vehicles.blacklist.add"
    },
    {
        "uri": "vehicles\/blacklist\/store",
        "name": "hatchly.vehicles.blacklist.store"
    },
    {
        "uri": "vehicles\/blacklist\/active-bookings",
        "name": "hatchly.vehicles.blacklist.active-bookings"
    },
    {
        "uri": "vehicles\/blacklist\/{registration_number}",
        "name": "hatchly.vehicles.blacklist.delete"
    },
    {
        "uri": "kiosks\/config",
        "name": "hatchly.kiosks.config.index"
    },
    {
        "uri": "kiosks\/config\/create",
        "name": "hatchly.kiosks.config.create"
    },
    {
        "uri": "kiosks\/config\/store",
        "name": "hatchly.kiosks.config.store"
    },
    {
        "uri": "kiosks\/config\/{config}\/edit",
        "name": "hatchly.kiosks.config.edit"
    },
    {
        "uri": "kiosks\/config\/{config}\/update",
        "name": "hatchly.kiosks.config.update"
    },
    {
        "uri": "kiosks\/config\/{config}\/delete",
        "name": "hatchly.kiosks.config.delete"
    },
    {
        "uri": "kiosks\/config\/kiosks\/{config}\/image\/reset\/{image}",
        "name": "hatchly.kiosks.image.reset"
    },
    {
        "uri": "analytics\/page-types",
        "name": "hatchly.analytics.page-types.index"
    },
    {
        "uri": "analytics\/page-types\/create",
        "name": "hatchly.analytics.page-types.create"
    },
    {
        "uri": "analytics\/page-types",
        "name": "hatchly.analytics.page-types.store"
    },
    {
        "uri": "analytics\/page-types\/{pageTypeId}",
        "name": "hatchly.analytics.page-types.update"
    },
    {
        "uri": "analytics\/page-types\/{pageTypeId}\/delete",
        "name": "hatchly.analytics.page-types.delete-confirm"
    },
    {
        "uri": "analytics\/page-types\/{pageTypeId}\/delete",
        "name": "hatchly.analytics.page-types.destroy"
    },
    {
        "uri": "analytics",
        "name": "hatchly.analytics.index"
    },
    {
        "uri": "analytics",
        "name": "hatchly.analytics.store"
    },
    {
        "uri": "analytics\/create",
        "name": "hatchly.analytics.create"
    },
    {
        "uri": "analytics\/{accountId}",
        "name": "hatchly.analytics.show"
    },
    {
        "uri": "analytics\/{accountId}",
        "name": "hatchly.analytics.update"
    },
    {
        "uri": "analytics\/{accountId}\/delete",
        "name": "hatchly.analytics.delete-confirm"
    },
    {
        "uri": "analytics\/{accountId}\/delete",
        "name": "hatchly.analytics.delete"
    },
    {
        "uri": "analytics\/{accountId}\/sync",
        "name": "hatchly.analytics.sync"
    },
    {
        "uri": "analytics\/branding\/{brandingId}",
        "name": "hatchly.analytics.branding.update"
    },
    {
        "uri": "analytics\/{accountId}\/users",
        "name": "hatchly.analytics.users.index"
    },
    {
        "uri": "analytics\/{accountId}\/users\/create",
        "name": "hatchly.analytics.users.create"
    },
    {
        "uri": "analytics\/{accountId}\/users",
        "name": "hatchly.analytics.users.store"
    },
    {
        "uri": "analytics\/{accountId}\/users\/{userId}\/delete",
        "name": "hatchly.analytics.users.delete-confirm"
    },
    {
        "uri": "analytics\/{accountId}\/users\/{userId}\/delete",
        "name": "hatchly.analytics.users.delete"
    },
    {
        "uri": "analytics\/{accountId}\/users\/{userId}\/sync",
        "name": "hatchly.analytics.users.sync"
    },
    {
        "uri": "analytics\/{accountId}\/pages",
        "name": "hatchly.analytics.pages.index"
    },
    {
        "uri": "analytics\/{accountId}\/pages\/create",
        "name": "hatchly.analytics.pages.create"
    },
    {
        "uri": "analytics\/{accountId}\/pages",
        "name": "hatchly.analytics.pages.store"
    },
    {
        "uri": "analytics\/{accountId}\/pages\/{pageId}",
        "name": "hatchly.analytics.pages.update"
    },
    {
        "uri": "analytics\/{accountId}\/pages\/{pageId}\/delete",
        "name": "hatchly.analytics.pages.delete-confirm"
    },
    {
        "uri": "analytics\/{accountId}\/pages\/{pageId}\/delete",
        "name": "hatchly.analytics.pages.delete"
    },
    {
        "uri": "vrn-lookup",
        "name": "hatchly.vrnlookup::index"
    },
    {
        "uri": "vrn-lookup\/extract-pcns",
        "name": "hatchly.vrnlookup::extract-pcns"
    },
    {
        "uri": "guest-validation\/company",
        "name": "hatchly.guest-validation.summary.index"
    },
    {
        "uri": "guest-validation\/company\/{config}\/view",
        "name": "hatchly.guest-validation.view"
    },
    {
        "uri": "guest-validation\/company\/{config}\/locations",
        "name": "hatchly.guest-validation.locations"
    },
    {
        "uri": "guest-validation\/company\/{config}\/update",
        "name": "hatchly.guest-validation.update"
    },
    {
        "uri": "guest-validation\/company\/store",
        "name": "hatchly.guest-validation.store"
    },
    {
        "uri": "guest-validation\/company\/{config}",
        "name": "hatchly.guest-validation.delete"
    },
    {
        "uri": "guest-validation\/qr-code\/create",
        "name": "hatchly.guest-validation.create"
    },
    {
        "uri": "control-frequency",
        "name": "hatchly.controlfrequency::index"
    },
    {
        "uri": "control-frequency\/create",
        "name": "hatchly.controlfrequency::create"
    },
    {
        "uri": "control-frequency",
        "name": "hatchly.controlfrequency::store"
    },
    {
        "uri": "control-frequency\/editFromSpace",
        "name": "hatchly.controlfrequency::editFromSpace"
    },
    {
        "uri": "control-frequency\/{space}",
        "name": "hatchly.controlfrequency::edit"
    },
    {
        "uri": "control-frequency\/{space}",
        "name": "hatchly.controlfrequency::update"
    },
    {
        "uri": "control-frequency\/{space}",
        "name": "hatchly.controlfrequency::destroy"
    },
    {
        "uri": "controlfreq",
        "name": "hatchly.controlfreq::index"
    },
    {
        "uri": "controlfreq\/create",
        "name": "hatchly.controlfreq::create"
    },
    {
        "uri": "controlfreq",
        "name": "hatchly.controlfreq::store"
    },
    {
        "uri": "controlfreq\/{space}",
        "name": "hatchly.controlfreq::destroy"
    },
    {
        "uri": "access-providers\/providers",
        "name": "hatchly.accessproviders::providers"
    },
    {
        "uri": "devices",
        "name": "hatchly.devices.index"
    },
    {
        "uri": "arrangement-fees\/locations",
        "name": "hatchly.arrangement-fees::index"
    },
    {
        "uri": "arrangement-fees\/locations\/store",
        "name": "hatchly.arrangement-fees::store"
    },
    {
        "uri": "arrangement-fees\/locations\/delete",
        "name": "hatchly.arrangement-fees::deleteBatch"
    },
    {
        "uri": "arrangement-fees\/locations\/delete\/{space_id}",
        "name": "hatchly.arrangement-fees::delete"
    },
    {
        "uri": "arrangement-fees\/locations\/import",
        "name": "hatchly.arrangement-fees::import"
    },
    {
        "uri": "arrangement-fees\/locations\/template",
        "name": "hatchly.arrangement-fees::template"
    },
    {
        "uri": "arrangement-fees\/settings",
        "name": "hatchly.arrangement-fees::settings"
    },
    {
        "uri": "products",
        "name": "hatchly.products.index"
    },
    {
        "uri": "products\/purchased",
        "name": "hatchly.products.purchased.index"
    },
    {
        "uri": "service-fee-bands",
        "name": "hatchly.service-fee-bands::index"
    },
    {
        "uri": "service-fee-bands\/update",
        "name": "hatchly.service-fee-bands::update"
    },
    {
        "uri": "service-fee-bands\/bulk-import",
        "name": "hatchly.service-fee-bands::bulk-import"
    },
    {
        "uri": "service-fee-bands\/bulk-import",
        "name": "hatchly.service-fee-bands::bulk-import.post"
    },
    {
        "uri": "incoming-booking-integrations",
        "name": "hatchly.incoming-booking-integrations::index"
    },
    {
        "uri": "incoming-booking-integrations\/ring-go",
        "name": "hatchly.incoming-booking-integrations::ring-go.index"
    },
    {
        "uri": "incoming-booking-integrations\/ring-go\/locations",
        "name": "hatchly.incoming-booking-integrations::ring-go.locations.index"
    },
    {
        "uri": "incoming-booking-integrations\/ring-go\/locations\/create",
        "name": "hatchly.incoming-booking-integrations::ring-go.locations.create"
    },
    {
        "uri": "incoming-booking-integrations\/ring-go\/locations",
        "name": "hatchly.incoming-booking-integrations::ring-go.locations.store"
    },
    {
        "uri": "reservation-fees",
        "name": "hatchly.reservation-fee::settings.index"
    },
    {
        "uri": "reservation-fees\/exemptions",
        "name": "hatchly.reservation-fee::exemptions.index"
    },
    {
        "uri": "reservation-fees\/exemptions",
        "name": "hatchly.reservation-fee::exemptions.store"
    },
    {
        "uri": "reservation-fees\/exemptions\/create-template",
        "name": "hatchly.reservation-fee::exemptions.create.template"
    },
    {
        "uri": "reservation-fees\/exemptions\/bulk-import",
        "name": "hatchly.reservation-fee::exemptions.store.bulk"
    },
    {
        "uri": "reservation-fees\/exemptions\/bulk-delete",
        "name": "hatchly.reservation-fee::exemptions.delete.bulk"
    },
    {
        "uri": "reservation-fees\/exemptions\/{space_id}",
        "name": "hatchly.reservation-fee::exemptions.delete"
    }
],
            prefix: '',

            route : function (name, parameters, route) {
                route = route || this.getByName(name);

                if ( ! route ) {
                    return undefined;
                }

                return this.toRoute(route, parameters);
            },

            toRoute : function (route, parameters) {
                var uri = this.replaceNamedParameters(route.uri, parameters);
                var usedParams = this.replacedNamedParameters(route.uri, parameters);
                var remainingParamKeys = window.difference(Object.keys(parameters), usedParams);
                var remainingParams = window.pickBy(parameters, function(val, key) {
                    return window.findIndex(remainingParamKeys, function(k) {
                        return k == key;
                    }) >= 0;
                });

                var qs  = this.getRouteQueryString(remainingParams);

                if (this.absolute && this.isOtherHost(route)){
                    return "//" + route.host + "/" + uri + qs;
                }

                return this.getCorrectUrl(uri + qs);
            },

            isOtherHost: function (route){
                return route.host && route.host != window.location.hostname;
            },

            replaceNamedParameters : function (uri, parameters) {
                uri = uri.replace(/\{(.*?)\??\}/g, function(match, key) {
                    if (parameters.hasOwnProperty(key)) {
                        var value = parameters[key];
                        delete parameters[key];
                        return value;
                    } else {
                        return match;
                    }
                });

                // Strip out any optional parameters that were not given
                uri = uri.replace(/\/\{.*?\?\}/g, '');

                return uri;
            },

            replacedNamedParameters : function (uri, parameters) {
                parameters = cloneDeep(parameters);
                var usedParams = [];

                uri = uri.replace(/\{(.*?)\??\}/g, function(match, key) {
                    if (parameters.hasOwnProperty(key)) {

                        usedParams.push(key);

                        var value = parameters[key];
                        delete parameters[key];
                        return value;
                    } else {
                        return match;
                    }
                });

                return usedParams;
            },

            getRouteQueryString : function (parameters) {
                var qs = [];
                for (var key in parameters) {
                    if (parameters.hasOwnProperty(key)) {
                        qs.push(key + '=' + parameters[key]);
                    }
                }

                if (qs.length < 1) {
                    return '';
                }

                return '?' + qs.join('&');
            },

            getByName : function (name) {
                for (var key in this.routes) {
                    if (this.routes.hasOwnProperty(key) && this.routes[key].name === name) {
                        return this.routes[key];
                    }
                }
            },

            getCorrectUrl: function (uri) {
                var url = this.prefix + '/' + uri.replace(/^\/?/, '');

                if ( ! this.absolute) {
                    return url;
                }

                return this.rootUrl.replace('/\/?$/', '') + url;
            },

            convertUriToRegex: function (route) {
                if (route.substr(0, 1) !== '/') {
                    route = '/' + route;
                }
                return route.replace(/\//g, '\\/').replace(/{.*?}/g, '[a-zA-Z0-9-_]+');
            },

            currentRoute: function () {
                return routes.routes.find(function (route) {
                    var regex = new RegExp('^' + routes.convertUriToRegex(route.uri) + '$');
                    return regex.test(window.location.pathname);
                });
            }
        };

        return {
            // Generate a url for a given named route.
            // YPS.router.route('routeName', [params = {}])
            route : function (route, parameters) {
                // If no route provided, we'll return
                // the current route data
                if (typeof route === 'undefined') {
                    return routes.currentRoute();
                }

                parameters = parameters || {};

                return routes.route(route, parameters);
            }
        };

    }).call(this);

    /**
     * Expose the class either via AMD, CommonJS or the global object
     */
    if (typeof define === 'function' && define.amd) {
        define(function () {
            return laroute;
        });
    }
    else if (typeof module === 'object' && module.exports){
        module.exports = laroute;
    }
    else {
        window.YPS.router = laroute;
    }

}).call(this);
